import { storage, redirectTo } from '@wave/utils';
import React, { useState, useEffect, useContext } from 'react';
import { ErrorIcon, ConditionalContent, Dialog, PageLoader, colors, SuccessIcon, PrimaryButton, useFormContext, PrimaryButtonLoader, FormSubmitButton, Form, FormErrorBox, Disclaimer, Table, ColumnsContainer, PageTitle, TableToolbar, Menu, IconText, AvatarInitials, AvatarIcon, Widget, DenseTable, TableRow, TableCell, FormSuccessBox, InfoMessageBox, PasswordInput, NewPasswordInput, ConfirmPasswordInput, PersonIcon, LockIcon, WidgetButton, ExitToAppIcon, IconButtonLoader, ErrorBox, DownloadIcon } from '@wave/components';
import { useTranslation } from 'react-i18next';
import { useHistory, BrowserRouter, Route, Redirect, Link, Switch, useRouteMatch, NavLink } from 'react-router-dom';
import { useDialog } from '@wave/hooks';

const access_token = () => {
  let token = '';

  const setToken = newToken => {
    token = newToken;
  };

  const getToken = () => {
    return token;
  };

  const setTempToken = newToken => {
    storage.setItem({
      key: 'token',
      value: newToken,
      expiresInDays: 0,
      storage: storage.STORAGE_TYPE.Cookies
    });
  };

  const getTempToken = () => {
    return storage.getItem({
      key: 'token'
    });
  };

  const removeTempToken = () => {
    storage.removeItem({
      key: 'token',
      storage: storage.STORAGE_TYPE.Cookies
    });
  };

  return {
    setToken,
    getToken,
    setTempToken,
    getTempToken,
    removeTempToken
  };
};

const accessToken = access_token();

const setToken = ({
  token
}) => {
  accessToken.setToken(token);
};

const setTempToken = ({
  token
}) => {
  accessToken.setTempToken(token);
};

const removeToken = () => {
  accessToken.setToken('');
};

const clearAuthTokens = () => {
  removeToken();
  accessToken.removeTempToken();
  storage.removeItem({
    key: 'refresh'
  });
};

const authStorage = { ...accessToken,
  setToken,
  removeToken,
  clearAuthTokens,
  setTempToken
};

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    return fn.apply(thisArg, args);
  };
};

var toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */

function isArray(val) {
  return toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */


function isUndefined(val) {
  return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */


function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */


function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */


function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */


function isArrayBufferView(val) {
  var result;

  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }

  return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */


function isString(val) {
  return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */


function isNumber(val) {
  return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */


function isObject(val) {
  return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */


function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */


function isDate(val) {
  return toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */


function isFile(val) {
  return toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */


function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */


function isFunction(val) {
  return toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */


function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */


function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */


function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */


function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */


function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  } // Force an array if not already something iterable


  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */


function merge() {
  var result = {};

  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }

  return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */


function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */


function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }

  return content;
}

var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */


var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;

  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }

        parts.push(encode(key) + '=' + encode(v));
      });
    });
    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */


InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */


InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */


InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;

  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };

  return error;
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */


var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */


var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;

  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

var cookies = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */


var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }

  return requestedURL;
};

// c.f. https://nodejs.org/api/http.html#http_message_headers


var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */

var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }

      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var isURLSameOrigin = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */

  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);
  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */

  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest(); // HTTP basic authentication

    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      } // Prepare the response


      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(resolve, reject, response); // Clean up request

      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        } // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request


        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        } // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'


        setTimeout(onloadend);
      };
    } // Handle browser request cancellation (as opposed to a manual cancellation)


    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Handle low level network errors


    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request)); // Clean up request

      request = null;
    }; // Handle timeout


    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';

      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }

      reject(createError(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.


    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    } // Add headers to the request


    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    } // Add withCredentials to request if needed


    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    } // Add responseType to request if needed


    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    } // Handle progress if needed


    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    } // Not all browsers support upload events


    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel); // Clean up request

        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    } // Send the request


    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;

  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }

  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }

    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }

    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    if (utils.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],
  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }

          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */


var transformData = function transformData(data, headers, fns) {
  var context = this || defaults_1;
  /*eslint no-param-reassign:0*/

  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });
  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/**
 * Throws a `Cancel` if cancellation has been requested.
 */


function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */


var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config); // Ensure headers exist

  config.headers = config.headers || {}; // Transform request data

  config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults_1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config); // Transform response data

    response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config); // Transform response data

      if (reason && reason.response) {
        reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */


var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};
  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }

    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });
  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils.forEach(otherKeys, mergeDeepProperties);
  return config;
};

var name = "axios";
var version = "0.21.4";
var description = "Promise based HTTP client for the browser and node.js";
var main = "index.js";
var scripts = {
	test: "grunt test",
	start: "node ./sandbox/server.js",
	build: "NODE_ENV=production grunt build",
	preversion: "npm test",
	version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
	postversion: "git push && git push --tags",
	examples: "node ./examples/server.js",
	coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
	fix: "eslint --fix lib/**/*.js"
};
var repository = {
	type: "git",
	url: "https://github.com/axios/axios.git"
};
var keywords = [
	"xhr",
	"http",
	"ajax",
	"promise",
	"node"
];
var author = "Matt Zabriskie";
var license = "MIT";
var bugs = {
	url: "https://github.com/axios/axios/issues"
};
var homepage = "https://axios-http.com";
var devDependencies = {
	coveralls: "^3.0.0",
	"es6-promise": "^4.2.4",
	grunt: "^1.3.0",
	"grunt-banner": "^0.6.0",
	"grunt-cli": "^1.2.0",
	"grunt-contrib-clean": "^1.1.0",
	"grunt-contrib-watch": "^1.0.0",
	"grunt-eslint": "^23.0.0",
	"grunt-karma": "^4.0.0",
	"grunt-mocha-test": "^0.13.3",
	"grunt-ts": "^6.0.0-beta.19",
	"grunt-webpack": "^4.0.2",
	"istanbul-instrumenter-loader": "^1.0.0",
	"jasmine-core": "^2.4.1",
	karma: "^6.3.2",
	"karma-chrome-launcher": "^3.1.0",
	"karma-firefox-launcher": "^2.1.0",
	"karma-jasmine": "^1.1.1",
	"karma-jasmine-ajax": "^0.1.13",
	"karma-safari-launcher": "^1.0.0",
	"karma-sauce-launcher": "^4.3.6",
	"karma-sinon": "^1.0.5",
	"karma-sourcemap-loader": "^0.3.8",
	"karma-webpack": "^4.0.2",
	"load-grunt-tasks": "^3.5.2",
	minimist: "^1.2.0",
	mocha: "^8.2.1",
	sinon: "^4.5.0",
	"terser-webpack-plugin": "^4.2.3",
	typescript: "^4.0.5",
	"url-search-params": "^0.10.0",
	webpack: "^4.44.2",
	"webpack-dev-server": "^3.11.0"
};
var browser = {
	"./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
var jsdelivr = "dist/axios.min.js";
var unpkg = "dist/axios.min.js";
var typings = "./index.d.ts";
var dependencies = {
	"follow-redirects": "^1.14.0"
};
var bundlesize = [
	{
		path: "./dist/axios.min.js",
		threshold: "5kB"
	}
];
var pkg = {
	name: name,
	version: version,
	description: description,
	main: main,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	browser: browser,
	jsdelivr: jsdelivr,
	unpkg: unpkg,
	typings: typings,
	dependencies: dependencies,
	bundlesize: bundlesize
};

var validators$1 = {}; // eslint-disable-next-line func-names

['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});
var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */

function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');

  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }

  return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */


validators$1.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  } // eslint-disable-next-line func-names


  return function (value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }

    return validator ? validator(value, opt, opts) : true;
  };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */


function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }

  var keys = Object.keys(options);
  var i = keys.length;

  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];

    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);

      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }

      continue;
    }

    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators$1
};

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */

function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */


Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config); // Set config.method

  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  } // filter out skipped interceptors


  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);

    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }

  var newConfig = config;

  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();

    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
}; // Provide aliases for supported request methods


utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
var Axios_1 = Axios;

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */


function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */


CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */


CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */

var isAxiosError = function isAxiosError(payload) {
  return typeof payload === 'object' && payload.isAxiosError === true;
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */


function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context); // Copy axios.prototype to instance

  utils.extend(instance, Axios_1.prototype, context); // Copy context to instance

  utils.extend(instance, context);
  return instance;
} // Create the default instance to be exported


var axios$1 = createInstance(defaults_1); // Expose Axios class to allow class inheritance

axios$1.Axios = Axios_1; // Factory for creating new instances

axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
}; // Expose Cancel & CancelToken


axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel; // Expose all/spread

axios$1.all = function all(promises) {
  return Promise.all(promises);
};

axios$1.spread = spread; // Expose isAxiosError

axios$1.isAxiosError = isAxiosError;
var axios_1 = axios$1; // Allow use of default import syntax in TypeScript

var _default = axios$1;
axios_1.default = _default;

var axios = axios_1;

const loginApi = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Appid: process.env.REACT_APP_APPID
  }
});
loginApi.interceptors.response.use(res => {
  return res;
}, error => {
  var _error$response;

  return Promise.reject(error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data);
});

const login = ({
  email,
  password
}) => {
  return loginApi.post('auth/local', {
    email,
    password
  });
};

const logout = () => {
  return axios.post('auth/local/logout', '', {
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      Appid: 'process.env.REACT_APP_APPID',
      Authorization: `Bearer ${authStorage.getToken()}`
    }
  });
};

const refreshToken = () => {
  return axios.get('/auth/local/refresh-token', {
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      Appid: process.env.REACT_APP_APPID
    }
  });
};

const apiConfig = {
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Appid: process.env.REACT_APP_APPID
  }
};
const requestSuccess = config => {
  const token = authStorage.getToken();

  if (!token) {
    if (config.headers.common && config.headers.common['Authorization']) delete config.headers.common['Authorization'];
  } else {
    config.headers.common['Authorization'] = `Bearer ${authStorage.getToken()}`;
  }

  return config;
};
const requestError = error => {
  return Promise.reject(error);
};
const asyncInterval = function (requestParameters, callback, ms, triesLeft = 12, runImmediately = true) {
  try {
    return Promise.resolve(new Promise(function (resolve, reject) {
      try {
        let _exit;

        function _temp2(_result) {
          if (_exit) return _result;
          const interval = setInterval(function () {
            try {
              let _exit2;

              return Promise.resolve(callback(requestParameters)).then(function (_callback2) {
                if (_callback2) {
                  resolve();
                  clearInterval(interval);
                  _exit2 = 1;
                  return;
                } else if (triesLeft <= 1) {
                  reject();
                  clearInterval(interval);
                  _exit2 = 1;
                  return;
                }

                triesLeft--;
              });
            } catch (e) {
              return Promise.reject(e);
            }
          }, ms);
        }

        const _temp = function () {
          if (runImmediately) {
            return Promise.resolve(callback(requestParameters)).then(function (_callback) {
              if (_callback) {
                resolve();
                _exit = 1;
                return;
              } else if (triesLeft <= 1) {
                reject();
                _exit = 1;
                return;
              }

              triesLeft--;
            });
          }
        }();

        return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
      } catch (e) {
        return Promise.reject(e);
      }
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

const fetcher$1 = url => api.get(url).then(res => res);
const api = axios.create(apiConfig);
api.interceptors.request.use(config => requestSuccess(config), error => requestError(error));
api.interceptors.response.use(res => {
  return res.data;
});
let isRefreshingToken = false;
let queuedRequests = new Map();
api.interceptors.response.use(response => response, function (error) {
  try {
    var _error$response;

    const originalRequest = error.config;

    if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) !== 401 || !originalRequest || originalRequest._isRetry) {
      var _error$response2;

      return Promise.reject(error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data);
    }

    originalRequest._isRetry = true;
    authStorage.removeToken();

    if (isRefreshingToken) {
      var _error$response3;

      queuedRequests.set(originalRequest === null || originalRequest === void 0 ? void 0 : originalRequest.url, originalRequest);
      return Promise.reject(error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data);
    }

    isRefreshingToken = true;
    return Promise.resolve(refreshToken().catch(tokenError => {
      isRefreshingToken = false;
      authStorage.clearAuthTokens();
      redirectTo(process.env.REACT_APP_AUTH_URL);
    })).then(function ({
      data: {
        token: newToken
      }
    }) {
      if (newToken) {
        authStorage.setToken({
          token: newToken
        });
      }

      originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
      return api(originalRequest).then(response => {
        for (let [key, queuedRequest] of queuedRequests) {
          queuedRequest.headers['Authorization'] = `Bearer ${newToken}`;
          api(queuedRequest);
          queuedRequests.delete(key);
        }

        return response;
      }).finally(() => {
        isRefreshingToken = false;
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
});

const fetcher = url => apiBlob.get(url).then(res => res);
const apiBlob = axios.create(apiConfig);
apiBlob.interceptors.request.use(config => requestSuccess(config), error => requestError(error));

const getUser = () => {
  return api.get('/users/me');
};

const setUserPassword = userInfo => {
  return api.put('/users/password', userInfo);
};

function _catch$3(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

const getUserToken = function () {
  try {
    function _temp3() {
      authStorage.setToken({
        token
      });
      return token;
    }

    let token = null;

    if (authStorage.getTempToken()) {
      token = authStorage.getTempToken();
      authStorage.removeTempToken();
    } else {
      token = authStorage.getToken();
    }

    const _temp2 = function () {
      if (!token) {
        const _temp = _catch$3(function () {
          return Promise.resolve(refreshToken()).then(function ({
            data: {
              token: newToken
            }
          }) {
            token = newToken;
          });
        }, function (e) {
          console.error(e);
        });

        if (_temp && _temp.then) return _temp.then(function () {});
      }
    }();

    return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2));
  } catch (e) {
    return Promise.reject(e);
  }
};

function _catch$2(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

const useCheckUserToken = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    try {
      return Promise.resolve(getUserToken()).then(function (token) {
        function _temp3() {
          setLoading(false);
        }

        const _temp2 = function () {
          if (token) {
            const _temp = _catch$2(function () {
              return Promise.resolve(getUser()).then(function (user) {
                if (user) setUser(user);
              });
            }, function (e) {
              console.error(e);
              setLoading(false);
            });

            if (_temp && _temp.then) return _temp.then(function () {});
          }
        }();

        return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
      });
    } catch (e) {
      Promise.reject(e);
    }
  }, []);
  return {
    loading,
    user,
    setUser
  };
};

function _catch$1(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

const AuthUserContext = /*#__PURE__*/React.createContext();
const AuthUserProvider = ({
  children
}) => {
  const {
    loading,
    user,
    setUser
  } = useCheckUserToken();

  const logout$1 = function () {
    try {
      function _temp2() {
        setUser(null);
        authStorage.clearAuthTokens();
      }

      const _temp = _catch$1(function () {
        return Promise.resolve(logout()).then(function () {});
      }, function (err) {
        console.error(err);
      });

      return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return /*#__PURE__*/React.createElement(AuthUserContext.Provider, {
    value: {
      isLoggedIn: !!user,
      user,
      loading,
      logout: logout$1
    }
  }, children);
};
const useAuthUser = () => {
  return useContext(AuthUserContext);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function (a) {
  return z(a) === k;
};

var isContextProvider = function (a) {
  return z(a) === h;
};

var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function (a) {
  return z(a) === n;
};

var isFragment = function (a) {
  return z(a) === e;
};

var isLazy = function (a) {
  return z(a) === t;
};

var isMemo = function (a) {
  return z(a) === r;
};

var isPortal = function (a) {
  return z(a) === d;
};

var isProfiler = function (a) {
  return z(a) === g;
};

var isStrictMode = function (a) {
  return z(a) === f;
};

var isSuspense = function (a) {
  return z(a) === p;
};

var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function () {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function () {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});

var styles$n = {"container":"AuthorizedContentContainer-module_container_1a-PE","footer":"AuthorizedContentContainer-module_footer_eoA5J"};

const AuthorizedContentContainer = ({
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$n.container
  }, children, /*#__PURE__*/React.createElement("footer", {
    className: styles$n.footer
  }, "Wave CXM\xA9 ", new Date().getFullYear(), " Desquared. All rights reserved."));
};

AuthorizedContentContainer.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var styles$m = {"container":"SingleColumnLayout-module_container_1QH2L","column":"SingleColumnLayout-module_column_3-a0x"};

const SingleColumnLayout = ({
  title,
  children
}) => {
  return /*#__PURE__*/React.createElement(AuthorizedContentContainer, {
    title: title
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$m.container
  }, /*#__PURE__*/React.createElement("main", {
    className: styles$m.column
  }, children)));
};

var styles$l = {"container":"RestrictedPage-module_container_NdSAw","header":"RestrictedPage-module_header_ug_S8","text":"RestrictedPage-module_text_17eT9","icon":"RestrictedPage-module_icon_3r6Jz"};

const RestrictedPage = () => {
  const {
    t,
    ready
  } = useTranslation(['translation']);
  const baseName = 'translation:restricted.';
  if (!ready) return null;
  return /*#__PURE__*/React.createElement(SingleColumnLayout, null, /*#__PURE__*/React.createElement("div", {
    className: styles$l.container
  }, /*#__PURE__*/React.createElement("h1", {
    className: styles$l.header
  }, t(`${baseName}title`)), /*#__PURE__*/React.createElement(ErrorIcon, {
    className: styles$l.icon
  }), /*#__PURE__*/React.createElement("p", {
    className: styles$l.text
  }, t(`${baseName}description`))));
};

const LimitedAccessContent = ({
  permittedFor,
  isPage,
  children
}) => {
  var _authUser$user;

  const authUser = useAuthUser();
  const permissions = authUser === null || authUser === void 0 ? void 0 : (_authUser$user = authUser.user) === null || _authUser$user === void 0 ? void 0 : _authUser$user.permissions;
  const [permissionScope, permission] = permittedFor.split(':');
  const showOn = permissions !== null && permissions !== void 0 && permissions[permissionScope] ? permissions[permissionScope].includes(permission) : false;
  if (isPage && !showOn) return /*#__PURE__*/React.createElement(RestrictedPage, null);
  return /*#__PURE__*/React.createElement(ConditionalContent, {
    showOn: showOn
  }, children);
};

LimitedAccessContent.propTypes = {
  permittedFor: propTypes.string.isRequired,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var styles$k = {"form":"FormDialog-module_form_Gq-ft","buttonContainer":"FormDialog-module_buttonContainer_2hU05"};

var styles$j = {"title":"GeneralMessageDialog-module_title_2_E-r","dialog":"GeneralMessageDialog-module_dialog_-0761","content":"GeneralMessageDialog-module_content_3N3eO","actions":"GeneralMessageDialog-module_actions_1epn8"};

const GeneralMessageDialog = ({
  open,
  closeDialog,
  children,
  dialogActions,
  dialogHeader,
  showCloseButton = true,
  isLoading = false,
  scroll = 'body'
}) => {
  const darkBlue = colors.darkBlue;
  const size = 64;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: closeDialog,
    dialogActions: dialogActions,
    dialogHeader: dialogHeader,
    dialogHeaderClassName: styles$j.title,
    dialogClassName: styles$j.dialog,
    dialogContentClassName: styles$j.content,
    dialogActionsClassName: styles$j.actions,
    showCloseButton: showCloseButton,
    scroll: scroll
  }, /*#__PURE__*/React.createElement(ConditionalContent, {
    showOn: isLoading
  }, /*#__PURE__*/React.createElement(PageLoader, {
    loading: true,
    size: size,
    loaderColor: darkBlue,
    fullPage: false,
    backgroundColor: "transparent"
  })), /*#__PURE__*/React.createElement(ConditionalContent, {
    showOn: !isLoading
  }, children));
};

GeneralMessageDialog.propTypes = {
  open: propTypes.bool,
  closeDialog: propTypes.func,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  dialogActions: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  dialogHeader: propTypes.string,
  showCloseButton: propTypes.bool,
  disableBackdropClick: propTypes.bool,
  isLoading: propTypes.bool,
  scroll: propTypes.string
};

var styles$i = {"icon":"ResponseMessageDialog-module_icon_1dYxj"};

const ResponseMessageDialog = ({
  open = true,
  closeDialog,
  success = false,
  children,
  dialogHeader,
  dialogActions,
  isLoading
}) => {
  return /*#__PURE__*/React.createElement(GeneralMessageDialog, {
    open: open,
    closeDialog: closeDialog,
    dialogActions: dialogActions,
    dialogHeader: dialogHeader,
    isLoading: isLoading
  }, success ? /*#__PURE__*/React.createElement(SuccessIcon, {
    className: styles$i.icon
  }) : /*#__PURE__*/React.createElement(ErrorIcon, {
    className: styles$i.icon
  }), children);
};

ResponseMessageDialog.propTypes = {
  open: propTypes.bool,
  closeDialog: propTypes.func,
  success: propTypes.bool,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  dialogHeader: propTypes.string,
  dialogActions: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  isLoading: propTypes.bool
};

var styles$h = {"secondaryButton":"ConfirmationDialog-module_secondaryButton_2Fl3t"};

const ConfirmationDialog = ({
  open,
  closeDialog,
  dialogHeader,
  request,
  denyButtonLabel = '',
  acceptButtonLabel = '',
  errorButtonLabel = '',
  okButtonLabel = '',
  error,
  errorMessage,
  isLoading,
  children
}) => {
  const {
    t,
    ready
  } = useTranslation(['translation']);
  const translation = ready ? {
    denyButton: denyButtonLabel || t('translation:no'),
    acceptButton: acceptButtonLabel || t('translation:yes'),
    errorButton: errorButtonLabel || t('translation:retry'),
    okButton: okButtonLabel || t('translation:close')
  } : '';
  const errorMessageContent = errorMessage ? errorMessage : ready ? t('translation:something-wrong') : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConditionalContent, {
    showOn: error
  }, /*#__PURE__*/React.createElement(ResponseMessageDialog, {
    open: open,
    closeDialog: closeDialog,
    dialogHeader: dialogHeader,
    dialogActions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrimaryButton, {
      onClick: request,
      disabled: isLoading,
      className: styles$h.secondaryButton
    }, translation.errorButton), /*#__PURE__*/React.createElement(PrimaryButton, {
      onClick: closeDialog,
      disabled: isLoading
    }, translation.okButton)),
    isLoading: isLoading
  }, errorMessageContent)), /*#__PURE__*/React.createElement(ConditionalContent, {
    showOn: !error
  }, /*#__PURE__*/React.createElement(GeneralMessageDialog, {
    open: open,
    closeDialog: closeDialog,
    dialogActions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrimaryButton, {
      onClick: closeDialog,
      disabled: isLoading
    }, translation === null || translation === void 0 ? void 0 : translation.denyButton), /*#__PURE__*/React.createElement(PrimaryButton, {
      onClick: request,
      disabled: isLoading
    }, acceptButtonLabel || (translation === null || translation === void 0 ? void 0 : translation.acceptButton))),
    dialogHeader: dialogHeader,
    isLoading: isLoading
  }, children)));
};

GeneralMessageDialog.propTypes = {
  open: propTypes.bool,
  closeDialog: propTypes.func,
  dialogHeader: propTypes.string,
  request: propTypes.func,
  denyButtonLabel: propTypes.string,
  acceptButtonLabel: propTypes.string,
  errorButtonLabel: propTypes.string,
  okButtonLabel: propTypes.string,
  error: propTypes.any,
  errorMessage: propTypes.string,
  isLoading: propTypes.bool,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  lang: propTypes.string
};

const FormConfirmationButton = ({
  scope,
  label,
  className,
  confirmationHeader,
  confirmationBody,
  denyButtonLabel,
  acceptButtonLabel,
  retryButtonLabel,
  okButtonLabel
}) => {
  const {
    t,
    ready
  } = useTranslation([scope, 'translation']);
  const confirmation = ready ? t(`${scope}:modal`, {
    returnObjects: true
  }) : {};
  const standardLabel = ready ? t('translation:save') : '';
  const {
    isSubmitting,
    isDisabled,
    onSubmit,
    trigger,
    errors
  } = useFormContext();
  const {
    openDialog,
    isOpen,
    closeDialog
  } = useDialog();

  const onClick = () => {
    trigger();
    setTimeout(() => {
      if (Object.keys(errors).length === 0) openDialog();
    }, 10);
  };

  const onConfirmation = () => {
    onSubmit();
    closeDialog();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrimaryButtonLoader, {
    loading: isSubmitting,
    disabled: isDisabled || isSubmitting,
    type: "button",
    className: className,
    title: label || standardLabel,
    "aria-label": label || standardLabel,
    onClick: onClick
  }, label || standardLabel), /*#__PURE__*/React.createElement(ConfirmationDialog, {
    dialogHeader: confirmationHeader ? confirmationHeader : confirmation.confirmationHeader,
    request: onConfirmation,
    open: isOpen,
    closeDialog: closeDialog,
    denyButtonLabel: denyButtonLabel,
    acceptButtonLabel: acceptButtonLabel,
    errorButtonLabel: retryButtonLabel,
    okButtonLabel: okButtonLabel
  }, confirmationBody ? confirmationBody : confirmation.confirmationBody));
};

FormConfirmationButton.propTypes = {
  scope: propTypes.string,
  label: propTypes.string,
  className: propTypes.string,
  lang: propTypes.string,
  confirmationHeader: propTypes.string,
  confirmationBody: propTypes.string,
  denyButtonLabel: propTypes.string,
  acceptButtonLabel: propTypes.string,
  retryButtonLabel: propTypes.string,
  okButtonLabel: propTypes.string
};

var styles$g = {"button":"FormDialogButton-module_button_2EVrd"};

const FormDialogButton = ({
  defaultValues,
  disabledOnDefault,
  needsConfirmation,
  scope,
  submitLabel,
  buttonClass,
  lang,
  confirmationHeader,
  confirmationBody,
  denyButtonLabel,
  acceptButtonLabel,
  retryButtonLabel,
  okButtonLabel
}) => {
  const {
    disableForm,
    resetState,
    getValues
  } = useFormContext();
  useEffect(() => {
    if (defaultValues && disabledOnDefault) {
      const isDirty = Object.keys(getValues()).map(key => getValues(key) !== defaultValues[key]).includes(true);

      if (!isDirty) {
        disableForm();
      } else {
        resetState();
      }
    }
  }, [defaultValues, disableForm, disabledOnDefault, getValues, resetState]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConditionalContent, {
    showOn: needsConfirmation
  }, /*#__PURE__*/React.createElement(FormConfirmationButton, {
    scope: scope,
    lang: lang,
    label: submitLabel,
    className: `${styles$g.button} ${buttonClass}`,
    confirmationHeader: confirmationHeader,
    confirmationBody: confirmationBody,
    denyButtonLabel: denyButtonLabel,
    acceptButtonLabel: acceptButtonLabel,
    retryButtonLabel: retryButtonLabel,
    okButtonLabel: okButtonLabel
  })), /*#__PURE__*/React.createElement(ConditionalContent, {
    showOn: !needsConfirmation
  }, /*#__PURE__*/React.createElement(FormSubmitButton, {
    label: submitLabel,
    lang: lang,
    className: `${styles$g.button} ${buttonClass}`
  })));
};

FormDialogButton.propTypes = {
  scope: propTypes.string,
  disabledOnDefault: propTypes.bool,
  needsConfirmation: propTypes.bool,
  submitLabel: propTypes.string,
  buttonClass: propTypes.string,
  lang: propTypes.string,
  confirmationHeader: propTypes.string,
  confirmationBody: propTypes.string,
  denyButtonLabel: propTypes.string,
  acceptButtonLabel: propTypes.string,
  retryButtonLabel: propTypes.string,
  okButtonLabel: propTypes.string
};

const FormDialog = ({
  title,
  onSubmit,
  scope,
  children,
  disabledOnDefault,
  defaultValues,
  needsConfirmation,
  confirmationHeader,
  confirmationBody,
  denyButtonLabel,
  acceptButtonLabel,
  retryButtonLabel,
  okButtonLabel,
  formClassName,
  submitLabel,
  buttonClass,
  showBackButton = false,
  onBack = () => {},
  ...rest
}) => {
  const {
    i18n
  } = useTranslation();
  const lang = i18n.language;
  const history = useHistory();

  const onClose = () => history.goBack();

  return /*#__PURE__*/React.createElement(Dialog, _extends({
    dialogHeader: title,
    onClose: onClose,
    showBackButton: showBackButton,
    onBack: onBack
  }, rest), /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    className: styles$k.form,
    defaultValues: defaultValues
  }, /*#__PURE__*/React.createElement(FormErrorBox, {
    lang: lang,
    scope: scope
  }), children, /*#__PURE__*/React.createElement("div", {
    className: styles$k.buttonContainer
  }, /*#__PURE__*/React.createElement(FormDialogButton, {
    scope: scope,
    submitLabel: submitLabel,
    buttonClass: buttonClass,
    needsConfirmation: needsConfirmation,
    defaultValues: defaultValues,
    disabledOnDefault: disabledOnDefault,
    lang: lang,
    confirmationHeader: confirmationHeader,
    confirmationBody: confirmationBody,
    denyButtonLabel: denyButtonLabel,
    acceptButtonLabel: acceptButtonLabel,
    retryButtonLabel: retryButtonLabel,
    okButtonLabel: okButtonLabel
  }))));
};

FormDialog.propTypes = {
  title: propTypes.string,
  onSubmit: propTypes.func,
  scope: propTypes.string,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  disabledOnDefault: propTypes.bool,
  defaultValues: propTypes.object,
  needsConfirmation: propTypes.bool,
  confirmationHeader: propTypes.string,
  confirmationBody: propTypes.string,
  denyButtonLabel: propTypes.string,
  acceptButtonLabel: propTypes.string,
  retryButtonLabel: propTypes.string,
  okButtonLabel: propTypes.string,
  formClassName: propTypes.string,
  submitLabel: propTypes.string,
  buttonClass: propTypes.string,
  showBackButton: propTypes.bool,
  onBack: propTypes.func
};

const useTable = (name, param = '', tablesConfig, CustomToolbar, filterModel, sortModel, modeServer) => {
  const localName = param !== '' ? `${name}_${param}` : `${name}`;
  const [stored, setStored] = useState(() => JSON.parse(localStorage.getItem(localName)));
  const [filter, setFilter] = useState(filterModel);
  const [sort, setSort] = useState(sortModel);
  const rowsPerPage = 25;
  useEffect(() => {
    if (filterModel) {
      setFilter(filterModel);
    }
  }, [filterModel]);
  useEffect(() => {
    if (sortModel && sortModel !== []) {
      setSort(sortModel);
    }
  }, [sortModel]);
  useEffect(() => {
    let data = { ...stored
    };

    if (sort && sort !== []) {
      data = { ...data,
        sortModel: sort
      };
    }

    if (filter) {
      data = { ...data,
        filterModel: filter
      };
    }

    const storeData = () => {
      localStorage.setItem(localName, JSON.stringify({ ...data
      }));
    };

    storeData();
    return () => {
      storeData();
    };
  }, [filter, localName, sort, stored]);

  const createServerSortModel = model => {
    if (model !== null && model !== void 0 && model[0]) {
      var _model$, _model$2;

      return `sortField=${(_model$ = model[0]) === null || _model$ === void 0 ? void 0 : _model$.field}&sortDirection=${(_model$2 = model[0]) === null || _model$2 === void 0 ? void 0 : _model$2.sort}`;
    } else return null;
  };

  const dataFunction = tablesConfig[name].data;
  const data = dataFunction((stored === null || stored === void 0 ? void 0 : stored.page) || 0, createServerSortModel(stored === null || stored === void 0 ? void 0 : stored.sortModel), rowsPerPage);
  const {
    rows,
    columns,
    loading,
    error
  } = data;
  const paginationProps = modeServer ? {
    paginationMode: 'server',
    sortingMode: 'server',
    rowCount: data.rowCount,
    onPageChange: page => {
      if (page > data.rowCount / rowsPerPage) {
        page = page - 1;
      }

      setStored({ ...stored,
        page
      });
    }
  } : {};
  return {
    loading: loading,
    error: error,
    props: {
      rows: rows,
      columns: columns,
      page: (stored === null || stored === void 0 ? void 0 : stored.page) || 0,
      pageSize: rows && rows.length < rowsPerPage ? rows.length : rowsPerPage,
      rowsPerPageOptions: [rows && rows.length < rowsPerPage ? rows.length : rowsPerPage],
      onPageChange: page => {
        setStored({ ...stored,
          page
        });
      },
      onSortModelChange: model => {
        setStored({ ...stored,
          sortModel: model
        });
      },
      sortModel: sort || (stored === null || stored === void 0 ? void 0 : stored.sortModel) || [],
      onFilterModelChange: model => {
        setStored({ ...stored,
          page: 0,
          filterModel: model
        });
      },
      filterModel: filter || (stored === null || stored === void 0 ? void 0 : stored.filterModel) || {
        items: [],
        linkOperator: ''
      },
      components: {
        Toolbar: CustomToolbar
      },
      ...paginationProps
    }
  };
};

var styles$f = {"container":"TableContainer-module_container_1zGDN"};

const TableContainer = ({
  name,
  param,
  disclaimers = [],
  tablesConfig,
  Toolbar,
  tableProps,
  filterModel,
  sortModel,
  modeServer,
  lang
}) => {
  var _disclaimers;

  const {
    props,
    loading,
    error
  } = useTable(name, param, tablesConfig, Toolbar, filterModel, sortModel, modeServer);
  const mergedProps = { ...props,
    ...tableProps
  };
  disclaimers = disclaimers.length > 0 ? disclaimers.map((disclaimer, index) => /*#__PURE__*/React.createElement(Disclaimer, {
    key: `${disclaimer}-${index}`
  }, disclaimer)) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$f.container,
    style: {
      paddingBottom: `${((_disclaimers = disclaimers) === null || _disclaimers === void 0 ? void 0 : _disclaimers.length) + 1}rem`
    }
  }, /*#__PURE__*/React.createElement(Table, _extends({
    lang: lang,
    loading: loading,
    error: error
  }, mergedProps)), disclaimers);
};

TableContainer.propTypes = {
  name: propTypes.string,
  disclaimers: propTypes.array,
  tablesConfig: propTypes.object,
  loadingOverlay: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  modeServer: propTypes.bool,
  lang: propTypes.string
};

var styles$e = {"container":"FullWidthTableLayout-module_container_mNVXM","headerContainer":"FullWidthTableLayout-module_headerContainer_1lCSV","buttonsContainer":"FullWidthTableLayout-module_buttonsContainer_15ARS"};

const FullWidthTableLayout = ({
  name,
  param,
  disclaimers = [],
  tablesConfig,
  children,
  ToolbarChild,
  tableProps,
  filterModel,
  sortModel,
  modeServer = false,
  lang
}) => {
  const {
    t,
    ready
  } = useTranslation([name]);
  const title = ready ? t(`${name}:pageTitle`) : '';
  if (!ready) return /*#__PURE__*/React.createElement("p", null, "Loading...");

  const CustomToolbar = () => /*#__PURE__*/React.createElement(TableToolbar, {
    name: name
  }, ToolbarChild ? /*#__PURE__*/React.createElement(ToolbarChild, null) : null);

  return /*#__PURE__*/React.createElement(AuthorizedContentContainer, null, /*#__PURE__*/React.createElement(ColumnsContainer, {
    className: styles$e.headerContainer
  }, /*#__PURE__*/React.createElement(PageTitle, {
    title: title
  }), /*#__PURE__*/React.createElement(ColumnsContainer, {
    className: styles$e.buttonsContainer
  }, children)), /*#__PURE__*/React.createElement(TableContainer, {
    name: name,
    param: param,
    disclaimers: disclaimers,
    tablesConfig: tablesConfig,
    lang: lang,
    Toolbar: CustomToolbar,
    tableProps: tableProps,
    filterModel: filterModel,
    sortModel: sortModel,
    modeServer: modeServer
  }));
};

AuthorizedContentContainer.propTypes = {
  name: propTypes.string,
  disclaimers: propTypes.array,
  tablesConfig: propTypes.object,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  modeServer: propTypes.bool,
  lang: propTypes.string
};

/**
 * Validates if both of the DateRangePicker dates have been selected
 * @param {*} value - The DateRangePicker value
 * @returns boolean
 */
const validateDateRangePicker = value => {
  let isValidated = true;
  if (!value) return false;
  Object.keys(value).forEach(key => {
    if (!(value !== null && value !== void 0 && value[key])) {
      isValidated = false;
    }
  });
  return isValidated;
};

const characters = '$<>@#^[]{}?:;|\'\\",~`=.';
/**
 * Validates if the prefix has one of the invalid characters  $<>@#^[]{}?:;|\'\\",~`=.
 * @param {string} value - The prefix to validate
 * @returns boolean
 */

const validateCouponPrefix = value => {
  for (let i = 0; i < characters.length; i++) {
    if (value.indexOf(characters[i]) > -1) {
      return false;
    }
  }

  return true;
};

const SWRconfig = {
  onErrorRetry: (error, key, config, mutate, {
    retryCount
  }) => {
    if ((error === null || error === void 0 ? void 0 : error.status) === 404) return;
    if (retryCount >= 5) return;
    setTimeout(() => mutate({
      retryCount: retryCount + 1
    }), 5000);
  }
};

/**
 * Normalize all paths to not have trailing slashes even if they matched <Route> with one
 * @property {node|array<node>} children
 * @returns node
 */

const Router = ({
  children
}) => /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(Route, {
  render: ({
    location: {
      pathname,
      search,
      hash
    }
  }) => pathname !== '/' && pathname.slice(-1) === '/' ? /*#__PURE__*/React.createElement(Redirect, {
    to: `${pathname.slice(0, -1)}${search}${hash}`
  }) : children
}));

Router.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var styles$d = {"container":"AuthorizedContainer-module_container_2yV7W"};

const AuthorizedContainer = ({
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$d.container
  }, children);
};

AuthorizedContainer.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var styles$c = {"link":"NavigationLink-module_link_a_wEp"};

const NavigationLink = ({
  page,
  children,
  className
}) => {
  return page && page.startsWith('http') ? /*#__PURE__*/React.createElement("a", {
    href: page,
    className: `${styles$c.link} ${className}`,
    target: "_blank",
    rel: "noreferrer noopener"
  }, children) : /*#__PURE__*/React.createElement(Link, {
    key: page,
    to: page,
    className: `${styles$c.link} ${className}`
  }, children);
};

NavigationLink.propTypes = {
  page: propTypes.string.isRequired,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  className: propTypes.string
};

var styles$b = {"container":"Navigation-module_container_13vwe","menu":"Navigation-module_menu_2oM_k","text":"Navigation-module_text_1J__N"};

const Navigation = ({
  config
}) => {
  const {
    t,
    ready
  } = useTranslation([`${config.scope}`]);
  return /*#__PURE__*/React.createElement("nav", {
    className: styles$b.container
  }, config.navigation.map(element => {
    return element !== null && element !== void 0 && element.navComponent ? /*#__PURE__*/React.createElement(element.navComponent, {
      key: element.name,
      page: element.page
    }) : element !== null && element !== void 0 && element.subNavs ? /*#__PURE__*/React.createElement(Menu, {
      key: element.name,
      items: element.subNavs.map(subNav => /*#__PURE__*/React.createElement(NavigationLink, {
        key: subNav.name,
        page: subNav.page
      }, ready ? t(`${config.scope}:${subNav.text}`) : ''))
    }, /*#__PURE__*/React.createElement(IconText, {
      className: styles$b.menu,
      textClass: styles$b.text,
      icon: /*#__PURE__*/React.createElement(element.icon, {
        style: {
          color: 'white',
          width: '20px'
        }
      }),
      text: ready ? t(`${config.scope}:${element.text}`) : ''
    })) : /*#__PURE__*/React.createElement(NavigationLink, {
      key: element.name,
      page: element.page
    }, /*#__PURE__*/React.createElement(IconText, {
      textClass: styles$b.text,
      icon: /*#__PURE__*/React.createElement(element.icon, {
        style: {
          color: 'white',
          width: '20px'
        }
      }),
      text: ready ? t(`${config.scope}:${element.text}`) : ''
    }));
  }));
};

Navigation.propTypes = {
  config: propTypes.object.isRequired
};

var styles$a = {"header":"SideBar-module_header_23PNw","container":"SideBar-module_container_1Jksr","logo":"SideBar-module_logo_rIdUT","childrenContainer":"SideBar-module_childrenContainer_2Ndgz"};

const SideBar = ({
  logo,
  children
}) => {
  return /*#__PURE__*/React.createElement("header", {
    className: styles$a.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$a.container
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/",
    className: styles$a.logo
  }, logo), /*#__PURE__*/React.createElement("section", {
    className: styles$a.childrenContainer
  }, children)));
};

SideBar.propTypes = {
  logo: propTypes.node,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var styles$9 = {"logo":"AuthorizedLayout-module_logo_1aTkq"};

const logo = /*#__PURE__*/React.createElement("p", {
  className: styles$9.logo
}, "Wave CXM");

const AuthorizedLayout = ({
  title,
  config
}) => {
  return /*#__PURE__*/React.createElement(AuthorizedContainer, {
    title: title
  }, /*#__PURE__*/React.createElement(SideBar, {
    logo: logo
  }, /*#__PURE__*/React.createElement(Navigation, {
    config: config
  })), /*#__PURE__*/React.createElement(Switch, null, config.routes.map((route, index) => {
    var _route$redirectTo;

    return /*#__PURE__*/React.createElement(Route, {
      key: index,
      exact: route && route.exact,
      path: route.page
    }, route !== null && route !== void 0 && route.redirectTo ? /*#__PURE__*/React.createElement(Redirect, {
      to: (_route$redirectTo = route === null || route === void 0 ? void 0 : route.redirectTo) !== null && _route$redirectTo !== void 0 ? _route$redirectTo : '/'
    }) : /*#__PURE__*/React.createElement(route.component, null, (route === null || route === void 0 ? void 0 : route.subRoutes) && (route === null || route === void 0 ? void 0 : route.subRoutes) && /*#__PURE__*/React.createElement(Switch, null, route.subRoutes.map((subRoute, index) => {
      return subRoute !== null && subRoute !== void 0 && subRoute.redirectTo ? /*#__PURE__*/React.createElement(Redirect, {
        to: (subRoute === null || subRoute === void 0 ? void 0 : subRoute.redirectTo) || '/',
        key: index
      }) : /*#__PURE__*/React.createElement(Route, {
        key: index,
        exact: subRoute && subRoute.exact,
        path: subRoute === null || subRoute === void 0 ? void 0 : subRoute.path
      }, subRoute === null || subRoute === void 0 ? void 0 : subRoute.component);
    }))));
  }), /*#__PURE__*/React.createElement(Route, {
    render: () => /*#__PURE__*/React.createElement(Redirect, {
      to: config === null || config === void 0 ? void 0 : config.defaultUrl
    })
  })));
};

/**
 * Component that renders authorized content or redirects to login if the user is logged out
 * @property {node} component - The authorized page
 * @property {string} redirectTo - The Auth url
 * @returns node|undefined
 */

const AuthorizedRoute = ({
  redirectTo,
  config,
  ...rest
}) => {
  const {
    isLoggedIn,
    loading
  } = useAuthUser();
  if (loading) return /*#__PURE__*/React.createElement(PageLoader, null);
  if (!isLoggedIn && !loading) window.location.href = process.env.REACT_APP_AUTH_URL;
  return /*#__PURE__*/React.createElement(Route, _extends({
    render: () => /*#__PURE__*/React.createElement(AuthorizedLayout, {
      config: config,
      path: config === null || config === void 0 ? void 0 : config.defaultUrl
    })
  }, rest));
};

AuthorizedRoute.propTypes = {
  /**
   * The authorized page component
   */
  component: propTypes.node,

  /**
   * Auth app's URL
   */
  redirectTo: propTypes.string
};

var dayjs_min = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e() ;
  }(commonjsGlobal, function () {

    var t = 1e3,
        e = 6e4,
        n = 36e5,
        r = "millisecond",
        i = "second",
        s = "minute",
        u = "hour",
        a = "day",
        o = "week",
        f = "month",
        h = "quarter",
        c = "year",
        d = "date",
        $ = "Invalid Date",
        l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
        y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        M = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
    },
        m = function (t, e, n) {
      var r = String(t);
      return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    },
        g = {
      s: m,
      z: function (t) {
        var e = -t.utcOffset(),
            n = Math.abs(e),
            r = Math.floor(n / 60),
            i = n % 60;
        return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
      },
      m: function t(e, n) {
        if (e.date() < n.date()) return -t(n, e);
        var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
            i = e.clone().add(r, f),
            s = n - i < 0,
            u = e.clone().add(r + (s ? -1 : 1), f);
        return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
      },
      a: function (t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      },
      p: function (t) {
        return {
          M: f,
          y: c,
          w: o,
          d: a,
          D: d,
          h: u,
          m: s,
          s: i,
          ms: r,
          Q: h
        }[t] || String(t || "").toLowerCase().replace(/s$/, "");
      },
      u: function (t) {
        return void 0 === t;
      }
    },
        D = "en",
        v = {};

    v[D] = M;

    var p = function (t) {
      return t instanceof _;
    },
        S = function (t, e, n) {
      var r;
      if (!t) return D;
      if ("string" == typeof t) v[t] && (r = t), e && (v[t] = e, r = t);else {
        var i = t.name;
        v[i] = t, r = i;
      }
      return !n && r && (D = r), r || !n && D;
    },
        w = function (t, e) {
      if (p(t)) return t.clone();
      var n = "object" == typeof e ? e : {};
      return n.date = t, n.args = arguments, new _(n);
    },
        O = g;

    O.l = S, O.i = p, O.w = function (t, e) {
      return w(t, {
        locale: e.$L,
        utc: e.$u,
        x: e.$x,
        $offset: e.$offset
      });
    };

    var _ = function () {
      function M(t) {
        this.$L = S(t.locale, null, !0), this.parse(t);
      }

      var m = M.prototype;
      return m.parse = function (t) {
        this.$d = function (t) {
          var e = t.date,
              n = t.utc;
          if (null === e) return new Date(NaN);
          if (O.u(e)) return new Date();
          if (e instanceof Date) return new Date(e);

          if ("string" == typeof e && !/Z$/i.test(e)) {
            var r = e.match(l);

            if (r) {
              var i = r[2] - 1 || 0,
                  s = (r[7] || "0").substring(0, 3);
              return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
            }
          }

          return new Date(e);
        }(t), this.$x = t.x || {}, this.init();
      }, m.init = function () {
        var t = this.$d;
        this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
      }, m.$utils = function () {
        return O;
      }, m.isValid = function () {
        return !(this.$d.toString() === $);
      }, m.isSame = function (t, e) {
        var n = w(t);
        return this.startOf(e) <= n && n <= this.endOf(e);
      }, m.isAfter = function (t, e) {
        return w(t) < this.startOf(e);
      }, m.isBefore = function (t, e) {
        return this.endOf(e) < w(t);
      }, m.$g = function (t, e, n) {
        return O.u(t) ? this[e] : this.set(n, t);
      }, m.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, m.valueOf = function () {
        return this.$d.getTime();
      }, m.startOf = function (t, e) {
        var n = this,
            r = !!O.u(e) || e,
            h = O.p(t),
            $ = function (t, e) {
          var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
          return r ? i : i.endOf(a);
        },
            l = function (t, e) {
          return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n);
        },
            y = this.$W,
            M = this.$M,
            m = this.$D,
            g = "set" + (this.$u ? "UTC" : "");

        switch (h) {
          case c:
            return r ? $(1, 0) : $(31, 11);

          case f:
            return r ? $(1, M) : $(0, M + 1);

          case o:
            var D = this.$locale().weekStart || 0,
                v = (y < D ? y + 7 : y) - D;
            return $(r ? m - v : m + (6 - v), M);

          case a:
          case d:
            return l(g + "Hours", 0);

          case u:
            return l(g + "Minutes", 1);

          case s:
            return l(g + "Seconds", 2);

          case i:
            return l(g + "Milliseconds", 3);

          default:
            return this.clone();
        }
      }, m.endOf = function (t) {
        return this.startOf(t, !1);
      }, m.$set = function (t, e) {
        var n,
            o = O.p(t),
            h = "set" + (this.$u ? "UTC" : ""),
            $ = (n = {}, n[a] = h + "Date", n[d] = h + "Date", n[f] = h + "Month", n[c] = h + "FullYear", n[u] = h + "Hours", n[s] = h + "Minutes", n[i] = h + "Seconds", n[r] = h + "Milliseconds", n)[o],
            l = o === a ? this.$D + (e - this.$W) : e;

        if (o === f || o === c) {
          var y = this.clone().set(d, 1);
          y.$d[$](l), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
        } else $ && this.$d[$](l);

        return this.init(), this;
      }, m.set = function (t, e) {
        return this.clone().$set(t, e);
      }, m.get = function (t) {
        return this[O.p(t)]();
      }, m.add = function (r, h) {
        var d,
            $ = this;
        r = Number(r);

        var l = O.p(h),
            y = function (t) {
          var e = w($);
          return O.w(e.date(e.date() + Math.round(t * r)), $);
        };

        if (l === f) return this.set(f, this.$M + r);
        if (l === c) return this.set(c, this.$y + r);
        if (l === a) return y(1);
        if (l === o) return y(7);
        var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[l] || 1,
            m = this.$d.getTime() + r * M;
        return O.w(m, this);
      }, m.subtract = function (t, e) {
        return this.add(-1 * t, e);
      }, m.format = function (t) {
        var e = this,
            n = this.$locale();
        if (!this.isValid()) return n.invalidDate || $;

        var r = t || "YYYY-MM-DDTHH:mm:ssZ",
            i = O.z(this),
            s = this.$H,
            u = this.$m,
            a = this.$M,
            o = n.weekdays,
            f = n.months,
            h = function (t, n, i, s) {
          return t && (t[n] || t(e, r)) || i[n].substr(0, s);
        },
            c = function (t) {
          return O.s(s % 12 || 12, t, "0");
        },
            d = n.meridiem || function (t, e, n) {
          var r = t < 12 ? "AM" : "PM";
          return n ? r.toLowerCase() : r;
        },
            l = {
          YY: String(this.$y).slice(-2),
          YYYY: this.$y,
          M: a + 1,
          MM: O.s(a + 1, 2, "0"),
          MMM: h(n.monthsShort, a, f, 3),
          MMMM: h(f, a),
          D: this.$D,
          DD: O.s(this.$D, 2, "0"),
          d: String(this.$W),
          dd: h(n.weekdaysMin, this.$W, o, 2),
          ddd: h(n.weekdaysShort, this.$W, o, 3),
          dddd: o[this.$W],
          H: String(s),
          HH: O.s(s, 2, "0"),
          h: c(1),
          hh: c(2),
          a: d(s, u, !0),
          A: d(s, u, !1),
          m: String(u),
          mm: O.s(u, 2, "0"),
          s: String(this.$s),
          ss: O.s(this.$s, 2, "0"),
          SSS: O.s(this.$ms, 3, "0"),
          Z: i
        };

        return r.replace(y, function (t, e) {
          return e || l[t] || i.replace(":", "");
        });
      }, m.utcOffset = function () {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m.diff = function (r, d, $) {
        var l,
            y = O.p(d),
            M = w(r),
            m = (M.utcOffset() - this.utcOffset()) * e,
            g = this - M,
            D = O.m(this, M);
        return D = (l = {}, l[c] = D / 12, l[f] = D, l[h] = D / 3, l[o] = (g - m) / 6048e5, l[a] = (g - m) / 864e5, l[u] = g / n, l[s] = g / e, l[i] = g / t, l)[y] || g, $ ? D : O.a(D);
      }, m.daysInMonth = function () {
        return this.endOf(f).$D;
      }, m.$locale = function () {
        return v[this.$L];
      }, m.locale = function (t, e) {
        if (!t) return this.$L;
        var n = this.clone(),
            r = S(t, e, !0);
        return r && (n.$L = r), n;
      }, m.clone = function () {
        return O.w(this.$d, this);
      }, m.toDate = function () {
        return new Date(this.valueOf());
      }, m.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, m.toISOString = function () {
        return this.$d.toISOString();
      }, m.toString = function () {
        return this.$d.toUTCString();
      }, M;
    }(),
        b = _.prototype;

    return w.prototype = b, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", f], ["$y", c], ["$D", d]].forEach(function (t) {
      b[t[1]] = function (e) {
        return this.$g(e, t[0], t[1]);
      };
    }), w.extend = function (t, e) {
      return t.$i || (t(e, _, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function (t) {
      return w(1e3 * t);
    }, w.en = v[D], w.Ls = v, w.p = {}, w;
  });
});

var utc = createCommonjsModule(function (module, exports) {
  !function (t, i) {
    module.exports = i() ;
  }(commonjsGlobal, function () {

    var t = "minute",
        i = /[+-]\d\d(?::?\d\d)?/g,
        e = /([+-]|\d\d)/g;
    return function (s, f, n) {
      var u = f.prototype;
      n.utc = function (t) {
        var i = {
          date: t,
          utc: !0,
          args: arguments
        };
        return new f(i);
      }, u.utc = function (i) {
        var e = n(this.toDate(), {
          locale: this.$L,
          utc: !0
        });
        return i ? e.add(this.utcOffset(), t) : e;
      }, u.local = function () {
        return n(this.toDate(), {
          locale: this.$L,
          utc: !1
        });
      };
      var o = u.parse;

      u.parse = function (t) {
        t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
      };

      var r = u.init;

      u.init = function () {
        if (this.$u) {
          var t = this.$d;
          this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
        } else r.call(this);
      };

      var a = u.utcOffset;

      u.utcOffset = function (s, f) {
        var n = this.$utils().u;
        if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
        if ("string" == typeof s && null === (s = function (t) {
          void 0 === t && (t = "");
          var s = t.match(i);
          if (!s) return null;
          var f = ("" + s[0]).match(e) || ["-", 0, 0],
              n = f[0],
              u = 60 * +f[1] + +f[2];
          return 0 === u ? 0 : "+" === n ? u : -u;
        }(s))) return this;
        var u = Math.abs(s) <= 16 ? 60 * s : s,
            o = this;
        if (f) return o.$offset = u, o.$u = 0 === s, o;

        if (0 !== s) {
          var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
        } else o = this.utc();

        return o;
      };

      var h = u.format;
      u.format = function (t) {
        var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return h.call(this, i);
      }, u.valueOf = function () {
        var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || new Date().getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * t;
      }, u.isUTC = function () {
        return !!this.$u;
      }, u.toISOString = function () {
        return this.toDate().toISOString();
      }, u.toString = function () {
        return this.toDate().toUTCString();
      };
      var l = u.toDate;

      u.toDate = function (t) {
        return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
      };

      var c = u.diff;

      u.diff = function (t, i, e) {
        if (t && this.$u === t.$u) return c.call(this, t, i, e);
        var s = this.local(),
            f = n(t).local();
        return c.call(s, f, i, e);
      };
    };
  });
});

var timezone = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e() ;
  }(commonjsGlobal, function () {

    var t = {
      year: 0,
      month: 1,
      day: 2,
      hour: 3,
      minute: 4,
      second: 5
    },
        e = {};
    return function (n, i, o) {
      var r,
          a = function (t, n, i) {
        void 0 === i && (i = {});
        var o = new Date(t);
        return function (t, n) {
          void 0 === n && (n = {});
          var i = n.timeZoneName || "short",
              o = t + "|" + i,
              r = e[o];
          return r || (r = new Intl.DateTimeFormat("en-US", {
            hour12: !1,
            timeZone: t,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            timeZoneName: i
          }), e[o] = r), r;
        }(n, i).formatToParts(o);
      },
          u = function (e, n) {
        for (var i = a(e, n), r = [], u = 0; u < i.length; u += 1) {
          var f = i[u],
              s = f.type,
              m = f.value,
              c = t[s];
          c >= 0 && (r[c] = parseInt(m, 10));
        }

        var d = r[3],
            l = 24 === d ? 0 : d,
            v = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000",
            h = +e;
        return (o.utc(v).valueOf() - (h -= h % 1e3)) / 6e4;
      },
          f = i.prototype;

      f.tz = function (t, e) {
        void 0 === t && (t = r);
        var n = this.utcOffset(),
            i = this.toDate(),
            a = i.toLocaleString("en-US", {
          timeZone: t
        }),
            u = Math.round((i - new Date(a)) / 1e3 / 60),
            f = o(a).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(i.getTimezoneOffset() / 15) - u, !0);

        if (e) {
          var s = f.utcOffset();
          f = f.add(n - s, "minute");
        }

        return f.$x.$timezone = t, f;
      }, f.offsetName = function (t) {
        var e = this.$x.$timezone || o.tz.guess(),
            n = a(this.valueOf(), e, {
          timeZoneName: t
        }).find(function (t) {
          return "timezonename" === t.type.toLowerCase();
        });
        return n && n.value;
      };
      var s = f.startOf;
      f.startOf = function (t, e) {
        if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
        var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"));
        return s.call(n, t, e).tz(this.$x.$timezone, !0);
      }, o.tz = function (t, e, n) {
        var i = n && e,
            a = n || e || r,
            f = u(+o(), a);
        if ("string" != typeof t) return o(t).tz(a);

        var s = function (t, e, n) {
          var i = t - 60 * e * 1e3,
              o = u(i, n);
          if (e === o) return [i, e];
          var r = u(i -= 60 * (o - e) * 1e3, n);
          return o === r ? [i, o] : [t - 60 * Math.min(o, r) * 1e3, Math.max(o, r)];
        }(o.utc(t, i).valueOf(), f, a),
            m = s[0],
            c = s[1],
            d = o(m).utcOffset(c);

        return d.$x.$timezone = a, d;
      }, o.tz.guess = function () {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, o.tz.setDefault = function (t) {
        r = t;
      };
    };
  });
});

dayjs_min.extend(utc);
dayjs_min.extend(timezone);

const formatDateToString = (date, timeZone = 'Europe/Athens') => {
  return dayjs_min(date).tz(timeZone).format('DD/MM/YYYY HH:mm');
};

const getTableColumns = (tables, tableType, titles) => {
  const config = tables[tableType].columns;
  const columns = Object.keys(config).map(key => {
    var _config$key2;

    const column = {
      field: key,
      headerName: titles[key],
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      filterable: true,
      hide: false,
      valueFormatter: params => {
        var _config$key;

        if (((_config$key = config[key]) === null || _config$key === void 0 ? void 0 : _config$key.type) !== 'boolean') {
          return params !== null && params !== void 0 && params.value ? params.value : '-';
        }

        return params !== null && params !== void 0 && params.value ? params.value : false;
      },
      ...config[key]
    };

    if (((_config$key2 = config[key]) === null || _config$key2 === void 0 ? void 0 : _config$key2.type) === 'dateTime') {
      column.valueFormatter = params => {
        return params !== null && params !== void 0 && params.value ? formatDateToString(params.value) : '-';
      };
    }

    return column;
  });
  return columns;
};
const getTableRows = data => {
  const rows = data.map((row, index) => {
    return {
      id: index,
      ...row
    };
  });
  return rows;
};
const sortStatus = (a, b) => {
  if (typeof a === 'string') return -1;
  if (typeof b === 'string') return 1;
  if (typeof a === 'string' && typeof b === 'string') return -1;
  return a > b ? 1 : a < b ? -1 : 0;
};

const NavigationAvatar = ({
  user
}) => {
  return user && user.firstName && user.lastName ? /*#__PURE__*/React.createElement(AvatarInitials, {
    name: user.firstName,
    lastName: user.lastName
  }) : /*#__PURE__*/React.createElement(AvatarIcon, null);
};

NavigationAvatar.propTypes = {
  user: propTypes.object
};

var styles$8 = {"link":"NavigationProfile-module_link_gDgZk"};

const NavigationProfile = ({
  page
}) => {
  const {
    user
  } = useAuthUser();
  return /*#__PURE__*/React.createElement(NavigationLink, {
    className: styles$8.link,
    page: page
  }, /*#__PURE__*/React.createElement(IconText, {
    icon: /*#__PURE__*/React.createElement(NavigationAvatar, {
      user: user
    }),
    text: user && user.firstName ? user.firstName : ''
  }));
};

NavigationProfile.propTypes = {
  page: propTypes.string.isRequired
};

const checkCouponCode = function (code) {
  try {
    return Promise.resolve(api.get(`/campaigns/coupons/check?code=${code}`)).then(function (couponObject) {
      return couponObject === null || couponObject === void 0 ? void 0 : couponObject.coupon;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

const redeemCoupon = data => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        success: true
      }); // reject({
      //   error: {
      //     response: {
      //       data: { error: { userMessage: 'Oh no! sth went wrong' } },
      //     },
      //   },
      // });
    }, 300);
  }); //TODO: replace with correct api when ready
  //return api.put('/campaigns/coupons/backoffice/redeem', data);
};

const cancelCoupon = data => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        success: true
      }); // reject({
      //   error: {
      //     response: {
      //       data: { error: { userMessage: 'Oh no! sth went wrong' } },
      //     },
      //   },
      // });
    }, 300);
  }); //TODO: replace with correct api when ready
  //return api.put('/campaigns/coupons/backoffice/redeem', data);
};

var styles$7 = {"container":"TwoColumnsLayout-module_container_13_ES","main":"TwoColumnsLayout-module_main_1ZwKc","right":"TwoColumnsLayout-module_right_1kViY"};

const TwoColumnsLayout = ({
  title,
  main,
  side
}) => {
  return /*#__PURE__*/React.createElement(AuthorizedContentContainer, null, /*#__PURE__*/React.createElement("div", {
    className: styles$7.container
  }, /*#__PURE__*/React.createElement("main", {
    className: styles$7.main
  }, main), /*#__PURE__*/React.createElement("aside", {
    className: styles$7.right
  }, side)));
};

TwoColumnsLayout.propTypes = {
  title: propTypes.string,
  main: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  side: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

const PersonalInfo = () => {
  const {
    user
  } = useAuthUser();
  const {
    t,
    ready
  } = useTranslation(['profile', 'translation']);
  const title = ready ? t('profile:mainTitle') : '';
  const headers = ready ? t('translation:headers', {
    returnObjects: true
  }) : {};
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(PageTitle, {
    title: title
  }), /*#__PURE__*/React.createElement(Widget, {
    backgroundColor: "white"
  }, /*#__PURE__*/React.createElement(DenseTable, {
    headerTitles: [headers === null || headers === void 0 ? void 0 : headers.field, headers === null || headers === void 0 ? void 0 : headers.value]
  }, /*#__PURE__*/React.createElement(TableRow, {
    key: (user === null || user === void 0 ? void 0 : user._id) + '0'
  }, /*#__PURE__*/React.createElement(TableCell, null, "Full Name"), /*#__PURE__*/React.createElement(TableCell, null, user === null || user === void 0 ? void 0 : user.firstName, " ", user === null || user === void 0 ? void 0 : user.lastName)), /*#__PURE__*/React.createElement(TableRow, {
    key: (user === null || user === void 0 ? void 0 : user._id) + '1'
  }, /*#__PURE__*/React.createElement(TableCell, null, "E mail"), /*#__PURE__*/React.createElement(TableCell, null, user === null || user === void 0 ? void 0 : user.email)), user !== null && user !== void 0 && user.corporateName ? /*#__PURE__*/React.createElement(TableRow, {
    key: (user === null || user === void 0 ? void 0 : user._id) + '2'
  }, /*#__PURE__*/React.createElement(TableCell, null, "Corporate Name"), /*#__PURE__*/React.createElement(TableCell, null, user === null || user === void 0 ? void 0 : user.corporateName)) : null)));
};

var styles$6 = {"buttonContainer":"ChangePassword-module_buttonContainer_s2929","successBox":"ChangePassword-module_successBox_1wqoB","errorBox":"ChangePassword-module_errorBox_3OM5h","successIcon":"ChangePassword-module_successIcon_2Xr9W"};

const ChangePassword = () => {
  const {
    t,
    ready
  } = useTranslation(['profile']);
  const title = ready ? t('profile:changePassword') : '';
  const rules = ready ? t('profile:passwordRules', {
    returnObjects: true
  }) : {};
  const password = ready ? t('profile:password') : '';
  const newPassword = ready ? t('profile:newPassword') : '';
  const repeatPassword = ready ? t('profile:repeatPassword') : '';
  const success = ready ? t('profile:success') : '';
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(PageTitle, {
    title: title
  }), /*#__PURE__*/React.createElement(Widget, {
    backgroundColor: "white"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: setUserPassword
  }, /*#__PURE__*/React.createElement(FormErrorBox, {
    className: styles$6.errorBox
  }), /*#__PURE__*/React.createElement(FormSuccessBox, {
    className: styles$6.successBox
  }, success), /*#__PURE__*/React.createElement(InfoMessageBox, {
    title: rules === null || rules === void 0 ? void 0 : rules.title,
    body: rules === null || rules === void 0 ? void 0 : rules.body
  }), /*#__PURE__*/React.createElement(PasswordInput, {
    name: "oldPassword",
    label: password
  }), /*#__PURE__*/React.createElement(NewPasswordInput, {
    name: "newPassword",
    label: newPassword
  }), /*#__PURE__*/React.createElement(ConfirmPasswordInput, {
    name: "repeatPassword",
    comparedInputName: "newPassword",
    label: repeatPassword
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$6.buttonContainer
  }, /*#__PURE__*/React.createElement(FormSubmitButton, null)))));
};

const ProfileMain = () => {
  const match = useRouteMatch();
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: `${match.url}/`,
    exact: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: `${match.url}/personal-details`
  })), /*#__PURE__*/React.createElement(Route, {
    path: `${match.url}/personal-details`
  }, /*#__PURE__*/React.createElement(PersonalInfo, null)), /*#__PURE__*/React.createElement(Route, {
    path: `${match.url}/change-password`
  }, /*#__PURE__*/React.createElement(ChangePassword, null)), /*#__PURE__*/React.createElement(Route, {
    path: `${match.url}/logout`
  }));
};

const LogoutDialog = ({
  open,
  closeDialog
}) => {
  const {
    logout
  } = useAuthUser();
  const {
    t,
    ready
  } = useTranslation(['profile', 'translation']);
  const title = ready ? t('profile:logout') : '';
  const body = ready ? t('profile:logoutConfirm') : '';
  const confirm = ready ? t('translation:confirm') : '';
  const cancel = ready ? t('translation:cancel') : '';
  return /*#__PURE__*/React.createElement(ConfirmationDialog, {
    open: open,
    closeDialog: closeDialog,
    dialogHeader: title,
    request: logout,
    denyButtonLabel: cancel,
    acceptButtonLabel: confirm,
    error: false
  }, body);
};

var styles$5 = {"buttonIcon":"ProfileSide-module_buttonIcon_1zoFy","buttonLabel":"ProfileSide-module_buttonLabel_2bzDo","toggleLabel":"ProfileSide-module_toggleLabel_1KVmG","link":"ProfileSide-module_link_1iVAg","selectedLink":"ProfileSide-module_selectedLink_2Pfpy"};

const ProfileSide = () => {
  const {
    isOpen,
    openDialog,
    closeDialog
  } = useDialog();
  const match = useRouteMatch().url;
  const {
    t,
    ready
  } = useTranslation(['profile']);
  const title = ready ? t('profile:sideTitle') : '';
  const personalInfo = ready ? t('profile:mainTitle') : '';
  const changePassword = ready ? t('profile:changePassword') : '';
  const logout = ready ? t('profile:logout') : '';
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(PageTitle, {
    title: title
  }), /*#__PURE__*/React.createElement(Widget, {
    backgroundColor: "white",
    padding: "0"
  }, /*#__PURE__*/React.createElement(NavLink, {
    activeClassName: styles$5.selectedLink,
    className: styles$5.link,
    to: `${match}/personal-details`
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$5.toggleLabel
  }, /*#__PURE__*/React.createElement(PersonIcon, {
    className: styles$5.buttonIcon
  }), personalInfo)), /*#__PURE__*/React.createElement(NavLink, {
    activeClassName: styles$5.selectedLink,
    className: styles$5.link,
    to: `${match}/change-password`
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$5.toggleLabel
  }, /*#__PURE__*/React.createElement(LockIcon, {
    className: styles$5.buttonIcon
  }), changePassword))), /*#__PURE__*/React.createElement(WidgetButton, {
    backgroundColor: "white",
    label: logout,
    "aria-label": logout,
    onClick: openDialog
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$5.buttonLabel
  }, /*#__PURE__*/React.createElement(ExitToAppIcon, {
    className: styles$5.buttonIcon
  }), logout)), /*#__PURE__*/React.createElement(LogoutDialog, {
    open: isOpen,
    closeDialog: closeDialog
  }));
};

const Profile = () => {
  return /*#__PURE__*/React.createElement(TwoColumnsLayout, {
    main: /*#__PURE__*/React.createElement(ProfileMain, null),
    side: /*#__PURE__*/React.createElement(ProfileSide, null)
  });
};

var styles$4 = {"button":"ActionIconButton-module_button__XHcc"};

const ActionIconButton = ({
  icon,
  label,
  onConfirm,
  onSuccess,
  className,
  confirmationHeader,
  confirmationBody,
  acceptButtonLabel,
  denyButtonLabel,
  retryButtonLabel,
  okButtonLabel
}) => {
  const {
    t,
    ready
  } = useTranslation(['translation']);
  const labels = ready ? {
    confirmationHeader: confirmationHeader !== null && confirmationHeader !== void 0 ? confirmationHeader : t('translation:confirm'),
    confirmationBody: confirmationBody !== null && confirmationBody !== void 0 ? confirmationBody : '',
    acceptButtonLabel: acceptButtonLabel !== null && acceptButtonLabel !== void 0 ? acceptButtonLabel : t('translation:yes'),
    denyButtonLabel: denyButtonLabel !== null && denyButtonLabel !== void 0 ? denyButtonLabel : t('translation:no'),
    retryButtonLabel: retryButtonLabel !== null && retryButtonLabel !== void 0 ? retryButtonLabel : t('translation:retry'),
    okButtonLabel: okButtonLabel !== null && okButtonLabel !== void 0 ? okButtonLabel : t('translation:ok'),
    action: label
  } : {};
  const {
    isOpen,
    isLoading,
    hasError,
    openDialog,
    closeDialog,
    startLoading,
    stopLoading,
    handleError,
    dialogErrorMessage
  } = useDialog();

  const onConfirmation = () => {
    startLoading();
    onConfirm().then(res => {
      if (typeof onSuccess === 'function') onSuccess(res);
      closeDialog();
    }, error => {
      handleError((error === null || error === void 0 ? void 0 : error.userMessage) || '');
    }).catch(error => {
      handleError((error === null || error === void 0 ? void 0 : error.userMessage) || '');
    }).finally(() => {
      stopLoading();
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButtonLoader, {
    loading: isLoading,
    disabled: isLoading,
    type: "button",
    title: labels.action,
    "aria-label": labels.action,
    onClick: openDialog,
    className: styles$4.button
  }, icon), /*#__PURE__*/React.createElement(ConfirmationDialog, {
    dialogHeader: labels.confirmationHeader,
    request: onConfirmation,
    open: isOpen,
    closeDialog: closeDialog,
    denyButtonLabel: labels.denyButtonLabel,
    acceptButtonLabel: labels.acceptButtonLabel,
    errorButtonLabel: labels.retryButtonLabel,
    okButtonLabel: labels.okButtonLabel,
    error: hasError,
    errorMessage: dialogErrorMessage,
    isLoading: isLoading
  }, labels.confirmationBody));
};

ActionIconButton.propTypes = {
  icon: propTypes.object.isRequired,
  scope: propTypes.string,
  label: propTypes.string,
  lang: propTypes.string,
  onConfirm: propTypes.func.isRequired,
  onSuccess: propTypes.func,
  className: propTypes.string,
  confirmationHeader: propTypes.string,
  confirmationBody: propTypes.string,
  denyButtonLabel: propTypes.string,
  acceptButtonLabel: propTypes.string,
  retryButtonLabel: propTypes.string,
  okButtonLabel: propTypes.string
};

var styles$3 = {"link":"IconLink-module_link_2Vq14"};

const IconLink = ({
  to,
  scope,
  titleTranslation,
  icon,
  className
}) => {
  const {
    t,
    ready
  } = useTranslation([`${scope}`]);
  const title = ready ? t(`${scope}:${titleTranslation}`) : '';
  return /*#__PURE__*/React.createElement(Link, {
    className: `${styles$3.link} ${className}`,
    to: to,
    "aria-label": title,
    title: title
  }, icon);
};

IconLink.propTypes = {
  to: propTypes.string,
  scope: propTypes.string,
  titleTranslation: propTypes.string,
  icon: propTypes.node,
  className: propTypes.string
};

const SubRouteButton = ({
  to,
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Link, {
    to: to
  }, /*#__PURE__*/React.createElement(PrimaryButton, rest, children));
};

SubRouteButton.propTypes = {
  to: propTypes.string,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var styles$2 = {"actionsContainer":"DetailsDialog-module_actionsContainer_3pAQn"};

const DetailsDialog = ({
  header,
  actions,
  titles,
  data
}) => {
  const {
    t,
    ready
  } = useTranslation(['translation']);
  const history = useHistory();

  const onClose = () => {
    history.goBack();
  };

  const tableHeaders = ready ? t('translation:headers', {
    returnObjects: true
  }) : {};
  const yes = ready ? t('translation:yes') : '';
  const no = ready ? t('translation:no') : '';
  const expired = ready ? t('translation:expired') : '';
  if (!data) return null;
  return /*#__PURE__*/React.createElement(Dialog, {
    dialogHeader: header,
    onClose: onClose,
    dialogActions: /*#__PURE__*/React.createElement("div", {
      className: styles$2.actionsContainer
    }, actions)
  }, /*#__PURE__*/React.createElement(DenseTable, {
    headerTitles: [tableHeaders === null || tableHeaders === void 0 ? void 0 : tableHeaders.field, tableHeaders === null || tableHeaders === void 0 ? void 0 : tableHeaders.value]
  }, Object.keys(titles).map(key => {
    if (typeof data[key] !== 'boolean' && !data[key]) return null;

    if (typeof data[key] === 'boolean') {
      if (data[key]) {
        data[key] = yes;
      } else {
        data[key] = no;
      }
    }

    if ((key === 'status' || key === 'enabled') && data[key] === 'expired') data[key] = expired;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: key
    }, /*#__PURE__*/React.createElement(TableCell, null, titles[key]), /*#__PURE__*/React.createElement(TableCell, null, data[key]));
  })));
};

DetailsDialog.propTypes = {
  header: propTypes.string,
  actions: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  titles: propTypes.object,
  data: propTypes.object
};

function getFormDataFromJson(object) {
  const formData = new FormData();
  Object.keys(object).forEach(key => {
    formData.append(key, object[key]);
  });
  return formData;
}

var styles$1 = {"box":"DialogErrorBox-module_box_HRQsk","title":"DialogErrorBox-module_title_2sP68","body":"DialogErrorBox-module_body_2XlEk"};

const DialogErrorBox = ({
  hasError,
  error,
  onClose
}) => {
  const {
    t,
    ready
  } = useTranslation(['translation']);
  const defaultErrorTitle = ready ? t('translation:attention') : '';
  const defaultErrorBody = ready ? t('translation:something-wrong') : '';
  const [errorTitle, setErrorTitle] = useState(defaultErrorTitle);
  const [errorBody, setErrorBody] = useState(defaultErrorBody);
  useEffect(() => {
    if (error !== null && error !== void 0 && error.userMessage) {
      setErrorBody(error === null || error === void 0 ? void 0 : error.userMessage);
    }

    if (error !== null && error !== void 0 && error.userTitle) {
      setErrorTitle(error === null || error === void 0 ? void 0 : error.userTitle);
    }
  }, [error]);
  return /*#__PURE__*/React.createElement(ErrorBox, {
    showError: Boolean(hasError),
    className: styles$1.box,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$1.title
  }, errorTitle), /*#__PURE__*/React.createElement("span", {
    className: styles$1.body
  }, errorBody));
};

const fileMimes = {
  x3d: 'application/vnd.hzn-3d-crossword',
  '3gp': 'video/3gpp',
  '3g2': 'video/3gpp2',
  mseq: 'application/vnd.mseq',
  pwn: 'application/vnd.3m.post-it-notes',
  plb: 'application/vnd.3gpp.pic-bw-large',
  psb: 'application/vnd.3gpp.pic-bw-small',
  pvb: 'application/vnd.3gpp.pic-bw-var',
  tcap: 'application/vnd.3gpp2.tcap',
  '7z': 'application/x-7z-compressed',
  abw: 'application/x-abiword',
  ace: 'application/x-ace-compressed',
  acc: 'application/vnd.americandynamics.acc',
  acu: 'application/vnd.acucobol',
  atc: 'application/vnd.acucorp',
  adp: 'audio/adpcm',
  aab: 'application/x-authorware-bin',
  aam: 'application/x-authorware-map',
  aas: 'application/x-authorware-seg',
  air: 'application/vnd.adobe.air-application-installer-package+zip',
  swf: 'application/x-shockwave-flash',
  fxp: 'application/vnd.adobe.fxp',
  pdf: 'application/pdf',
  ppd: 'application/vnd.cups-ppd',
  dir: 'application/x-director',
  xdp: 'application/vnd.adobe.xdp+xml',
  xfdf: 'application/vnd.adobe.xfdf',
  aac: 'audio/x-aac',
  ahead: 'application/vnd.ahead.space',
  azf: 'application/vnd.airzip.filesecure.azf',
  azs: 'application/vnd.airzip.filesecure.azs',
  azw: 'application/vnd.amazon.ebook',
  ami: 'application/vnd.amiga.ami',
  'N/A': 'application/andrew-inset',
  apk: 'application/vnd.android.package-archive',
  cii: 'application/vnd.anser-web-certificate-issue-initiation',
  fti: 'application/vnd.anser-web-funds-transfer-initiation',
  atx: 'application/vnd.antix.game-component',
  dmg: 'application/x-apple-diskimage',
  mpkg: 'application/vnd.apple.installer+xml',
  aw: 'application/applixware',
  mp3: 'audio/mpeg',
  les: 'application/vnd.hhe.lesson-player',
  swi: 'application/vnd.aristanetworks.swi',
  s: 'text/x-asm',
  atomcat: 'application/atomcat+xml',
  atomsvc: 'application/atomsvc+xml',
  'atom, .xml': 'application/atom+xml',
  ac: 'application/pkix-attr-cert',
  aif: 'audio/x-aiff',
  avi: 'video/x-msvideo',
  aep: 'application/vnd.audiograph',
  dxf: 'image/vnd.dxf',
  dwf: 'model/vnd.dwf',
  par: 'text/plain-bas',
  bcpio: 'application/x-bcpio',
  bin: 'application/octet-stream',
  bmp: 'image/bmp',
  torrent: 'application/x-bittorrent',
  cod: 'application/vnd.rim.cod',
  mpm: 'application/vnd.blueice.multipass',
  bmi: 'application/vnd.bmi',
  sh: 'application/x-sh',
  btif: 'image/prs.btif',
  rep: 'application/vnd.businessobjects',
  bz: 'application/x-bzip',
  bz2: 'application/x-bzip2',
  csh: 'application/x-csh',
  c: 'text/x-c',
  cdxml: 'application/vnd.chemdraw+xml',
  css: 'text/css',
  cdx: 'chemical/x-cdx',
  cml: 'chemical/x-cml',
  csml: 'chemical/x-csml',
  cdbcmsg: 'application/vnd.contact.cmsg',
  cla: 'application/vnd.claymore',
  c4g: 'application/vnd.clonk.c4group',
  sub: 'image/vnd.dvb.subtitle',
  cdmia: 'application/cdmi-capability',
  cdmic: 'application/cdmi-container',
  cdmid: 'application/cdmi-domain',
  cdmio: 'application/cdmi-object',
  cdmiq: 'application/cdmi-queue',
  c11amc: 'application/vnd.cluetrust.cartomobile-config',
  c11amz: 'application/vnd.cluetrust.cartomobile-config-pkg',
  ras: 'image/x-cmu-raster',
  dae: 'model/vnd.collada+xml',
  csv: 'text/csv',
  cpt: 'application/mac-compactpro',
  wmlc: 'application/vnd.wap.wmlc',
  cgm: 'image/cgm',
  ice: 'x-conference/x-cooltalk',
  cmx: 'image/x-cmx',
  xar: 'application/vnd.xara',
  cmc: 'application/vnd.cosmocaller',
  cpio: 'application/x-cpio',
  clkx: 'application/vnd.crick.clicker',
  clkk: 'application/vnd.crick.clicker.keyboard',
  clkp: 'application/vnd.crick.clicker.palette',
  clkt: 'application/vnd.crick.clicker.template',
  clkw: 'application/vnd.crick.clicker.wordbank',
  wbs: 'application/vnd.criticaltools.wbs+xml',
  cryptonote: 'application/vnd.rig.cryptonote',
  cif: 'chemical/x-cif',
  cmdf: 'chemical/x-cmdf',
  cu: 'application/cu-seeme',
  cww: 'application/prs.cww',
  curl: 'text/vnd.curl',
  dcurl: 'text/vnd.curl.dcurl',
  mcurl: 'text/vnd.curl.mcurl',
  scurl: 'text/vnd.curl.scurl',
  car: 'application/vnd.curl.car',
  pcurl: 'application/vnd.curl.pcurl',
  cmp: 'application/vnd.yellowriver-custom-menu',
  dssc: 'application/dssc+der',
  xdssc: 'application/dssc+xml',
  deb: 'application/x-debian-package',
  uva: 'audio/vnd.dece.audio',
  uvi: 'image/vnd.dece.graphic',
  uvh: 'video/vnd.dece.hd',
  uvm: 'video/vnd.dece.mobile',
  uvu: 'video/vnd.uvvu.mp4',
  uvp: 'video/vnd.dece.pd',
  uvs: 'video/vnd.dece.sd',
  uvv: 'video/vnd.dece.video',
  dvi: 'application/x-dvi',
  seed: 'application/vnd.fdsn.seed',
  dtb: 'application/x-dtbook+xml',
  res: 'application/x-dtbresource+xml',
  ait: 'application/vnd.dvb.ait',
  svc: 'application/vnd.dvb.service',
  eol: 'audio/vnd.digital-winds',
  djvu: 'image/vnd.djvu',
  dtd: 'application/xml-dtd',
  mlp: 'application/vnd.dolby.mlp',
  wad: 'application/x-doom',
  dpg: 'application/vnd.dpgraph',
  dra: 'audio/vnd.dra',
  dfac: 'application/vnd.dreamfactory',
  dts: 'audio/vnd.dts',
  dtshd: 'audio/vnd.dts.hd',
  dwg: 'image/vnd.dwg',
  geo: 'application/vnd.dynageo',
  es: 'application/ecmascript',
  mag: 'application/vnd.ecowin.chart',
  mmr: 'image/vnd.fujixerox.edmics-mmr',
  rlc: 'image/vnd.fujixerox.edmics-rlc',
  exi: 'application/exi',
  mgz: 'application/vnd.proteus.magazine',
  epub: 'application/epub+zip',
  eml: 'message/rfc822',
  nml: 'application/vnd.enliven',
  xpr: 'application/vnd.is-xpr',
  xif: 'image/vnd.xiff',
  xfdl: 'application/vnd.xfdl',
  emma: 'application/emma+xml',
  ez2: 'application/vnd.ezpix-album',
  ez3: 'application/vnd.ezpix-package',
  fst: 'image/vnd.fst',
  fvt: 'video/vnd.fvt',
  fbs: 'image/vnd.fastbidsheet',
  fe_launch: 'application/vnd.denovo.fcselayout-link',
  f4v: 'video/x-f4v',
  flv: 'video/x-flv',
  fpx: 'image/vnd.fpx',
  npx: 'image/vnd.net-fpx',
  flx: 'text/vnd.fmi.flexstor',
  fli: 'video/x-fli',
  ftc: 'application/vnd.fluxtime.clip',
  fdf: 'application/vnd.fdf',
  f: 'text/x-fortran',
  mif: 'application/vnd.mif',
  fm: 'application/vnd.framemaker',
  fh: 'image/x-freehand',
  fsc: 'application/vnd.fsc.weblaunch',
  fnc: 'application/vnd.frogans.fnc',
  ltf: 'application/vnd.frogans.ltf',
  ddd: 'application/vnd.fujixerox.ddd',
  xdw: 'application/vnd.fujixerox.docuworks',
  xbd: 'application/vnd.fujixerox.docuworks.binder',
  oas: 'application/vnd.fujitsu.oasys',
  oa2: 'application/vnd.fujitsu.oasys2',
  oa3: 'application/vnd.fujitsu.oasys3',
  fg5: 'application/vnd.fujitsu.oasysgp',
  bh2: 'application/vnd.fujitsu.oasysprs',
  spl: 'application/x-futuresplash',
  fzs: 'application/vnd.fuzzysheet',
  g3: 'image/g3fax',
  gmx: 'application/vnd.gmx',
  gtw: 'model/vnd.gtw',
  txd: 'application/vnd.genomatix.tuxedo',
  ggb: 'application/vnd.geogebra.file',
  ggt: 'application/vnd.geogebra.tool',
  gdl: 'model/vnd.gdl',
  gex: 'application/vnd.geometry-explorer',
  gxt: 'application/vnd.geonext',
  g2w: 'application/vnd.geoplan',
  g3w: 'application/vnd.geospace',
  gsf: 'application/x-font-ghostscript',
  bdf: 'application/x-font-bdf',
  gtar: 'application/x-gtar',
  texinfo: 'application/x-texinfo',
  gnumeric: 'application/x-gnumeric',
  kml: 'application/vnd.google-earth.kml+xml',
  kmz: 'application/vnd.google-earth.kmz',
  gqf: 'application/vnd.grafeq',
  gif: 'image/gif',
  gv: 'text/vnd.graphviz',
  gac: 'application/vnd.groove-account',
  ghf: 'application/vnd.groove-help',
  gim: 'application/vnd.groove-identity-message',
  grv: 'application/vnd.groove-injector',
  gtm: 'application/vnd.groove-tool-message',
  tpl: 'application/vnd.groove-tool-template',
  vcg: 'application/vnd.groove-vcard',
  h261: 'video/h261',
  h263: 'video/h263',
  h264: 'video/h264',
  hpid: 'application/vnd.hp-hpid',
  hps: 'application/vnd.hp-hps',
  hdf: 'application/x-hdf',
  rip: 'audio/vnd.rip',
  hbci: 'application/vnd.hbci',
  jlt: 'application/vnd.hp-jlyt',
  pcl: 'application/vnd.hp-pcl',
  hpgl: 'application/vnd.hp-hpgl',
  hvs: 'application/vnd.yamaha.hv-script',
  hvd: 'application/vnd.yamaha.hv-dic',
  hvp: 'application/vnd.yamaha.hv-voice',
  'sfd-hdstx': 'application/vnd.hydrostatix.sof-data',
  stk: 'application/hyperstudio',
  hal: 'application/vnd.hal+xml',
  html: 'text/html',
  irm: 'application/vnd.ibm.rights-management',
  sc: 'application/vnd.ibm.secure-container',
  ics: 'text/calendar',
  icc: 'application/vnd.iccprofile',
  ico: 'image/x-icon',
  igl: 'application/vnd.igloader',
  ief: 'image/ief',
  ivp: 'application/vnd.immervision-ivp',
  ivu: 'application/vnd.immervision-ivu',
  rif: 'application/reginfo+xml',
  '3dml': 'text/vnd.in3d.3dml',
  spot: 'text/vnd.in3d.spot',
  igs: 'model/iges',
  i2g: 'application/vnd.intergeo',
  cdy: 'application/vnd.cinderella',
  xpw: 'application/vnd.intercon.formnet',
  fcs: 'application/vnd.isac.fcs',
  ipfix: 'application/ipfix',
  cer: 'application/pkix-cert',
  pki: 'application/pkixcmp',
  crl: 'application/pkix-crl',
  pkipath: 'application/pkix-pkipath',
  igm: 'application/vnd.insors.igm',
  rcprofile: 'application/vnd.ipunplugged.rcprofile',
  irp: 'application/vnd.irepository.package+xml',
  jad: 'text/vnd.sun.j2me.app-descriptor',
  jar: 'application/java-archive',
  class: 'application/java-vm',
  jnlp: 'application/x-java-jnlp-file',
  ser: 'application/java-serialized-object',
  java: 'text/x-java-source,java',
  js: 'application/javascript',
  json: 'application/json',
  joda: 'application/vnd.joost.joda-archive',
  jpm: 'video/jpm',
  'jpeg, .jpg': 'image/x-citrix-jpeg',
  pjpeg: 'image/pjpeg',
  jpgv: 'video/jpeg',
  ktz: 'application/vnd.kahootz',
  mmd: 'application/vnd.chipnuts.karaoke-mmd',
  karbon: 'application/vnd.kde.karbon',
  chrt: 'application/vnd.kde.kchart',
  kfo: 'application/vnd.kde.kformula',
  flw: 'application/vnd.kde.kivio',
  kon: 'application/vnd.kde.kontour',
  kpr: 'application/vnd.kde.kpresenter',
  ksp: 'application/vnd.kde.kspread',
  kwd: 'application/vnd.kde.kword',
  htke: 'application/vnd.kenameaapp',
  kia: 'application/vnd.kidspiration',
  kne: 'application/vnd.kinar',
  sse: 'application/vnd.kodak-descriptor',
  lasxml: 'application/vnd.las.las+xml',
  latex: 'application/x-latex',
  lbd: 'application/vnd.llamagraphics.life-balance.desktop',
  lbe: 'application/vnd.llamagraphics.life-balance.exchange+xml',
  jam: 'application/vnd.jam',
  123: 'application/vnd.lotus-1-2-3',
  apr: 'application/vnd.lotus-approach',
  pre: 'application/vnd.lotus-freelance',
  nsf: 'application/vnd.lotus-notes',
  org: 'application/vnd.lotus-organizer',
  scm: 'application/vnd.lotus-screencam',
  lwp: 'application/vnd.lotus-wordpro',
  lvp: 'audio/vnd.lucent.voice',
  m3u: 'audio/x-mpegurl',
  m4v: 'video/x-m4v',
  hqx: 'application/mac-binhex40',
  portpkg: 'application/vnd.macports.portpkg',
  mgp: 'application/vnd.osgeo.mapguide.package',
  mrc: 'application/marc',
  mrcx: 'application/marcxml+xml',
  mxf: 'application/mxf',
  nbp: 'application/vnd.wolfram.player',
  ma: 'application/mathematica',
  mathml: 'application/mathml+xml',
  mbox: 'application/mbox',
  mc1: 'application/vnd.medcalcdata',
  mscml: 'application/mediaservercontrol+xml',
  cdkey: 'application/vnd.mediastation.cdkey',
  mwf: 'application/vnd.mfer',
  mfm: 'application/vnd.mfmp',
  msh: 'model/mesh',
  mads: 'application/mads+xml',
  mets: 'application/mets+xml',
  mods: 'application/mods+xml',
  meta4: 'application/metalink4+xml',
  mcd: 'application/vnd.mcd',
  flo: 'application/vnd.micrografx.flo',
  igx: 'application/vnd.micrografx.igx',
  es3: 'application/vnd.eszigno3+xml',
  mdb: 'application/x-msaccess',
  asf: 'video/x-ms-asf',
  exe: 'application/x-msdownload',
  cil: 'application/vnd.ms-artgalry',
  cab: 'application/vnd.ms-cab-compressed',
  ims: 'application/vnd.ms-ims',
  application: 'application/x-ms-application',
  clp: 'application/x-msclip',
  mdi: 'image/vnd.ms-modi',
  eot: 'application/vnd.ms-fontobject',
  xls: 'application/vnd.ms-excel',
  xlam: 'application/vnd.ms-excel.addin.macroenabled.12',
  xlsb: 'application/vnd.ms-excel.sheet.binary.macroenabled.12',
  xltm: 'application/vnd.ms-excel.template.macroenabled.12',
  xlsm: 'application/vnd.ms-excel.sheet.macroenabled.12',
  chm: 'application/vnd.ms-htmlhelp',
  crd: 'application/x-mscardfile',
  lrm: 'application/vnd.ms-lrm',
  mvb: 'application/x-msmediaview',
  mny: 'application/x-msmoney',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  sldx: 'application/vnd.openxmlformats-officedocument.presentationml.slide',
  ppsx: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  potx: 'application/vnd.openxmlformats-officedocument.presentationml.template',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  obd: 'application/x-msbinder',
  thmx: 'application/vnd.ms-officetheme',
  onetoc: 'application/onenote',
  pya: 'audio/vnd.ms-playready.media.pya',
  pyv: 'video/vnd.ms-playready.media.pyv',
  ppt: 'application/vnd.ms-powerpoint',
  ppam: 'application/vnd.ms-powerpoint.addin.macroenabled.12',
  sldm: 'application/vnd.ms-powerpoint.slide.macroenabled.12',
  pptm: 'application/vnd.ms-powerpoint.presentation.macroenabled.12',
  ppsm: 'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
  potm: 'application/vnd.ms-powerpoint.template.macroenabled.12',
  mpp: 'application/vnd.ms-project',
  pub: 'application/x-mspublisher',
  scd: 'application/x-msschedule',
  xap: 'application/x-silverlight-app',
  stl: 'application/vnd.ms-pki.stl',
  cat: 'application/vnd.ms-pki.seccat',
  vsd: 'application/vnd.visio',
  vsdx: 'application/vnd.visio2013',
  wm: 'video/x-ms-wm',
  wma: 'audio/x-ms-wma',
  wax: 'audio/x-ms-wax',
  wmx: 'video/x-ms-wmx',
  wmd: 'application/x-ms-wmd',
  wpl: 'application/vnd.ms-wpl',
  wmz: 'application/x-ms-wmz',
  wmv: 'video/x-ms-wmv',
  wvx: 'video/x-ms-wvx',
  wmf: 'application/x-msmetafile',
  trm: 'application/x-msterminal',
  doc: 'application/msword',
  docm: 'application/vnd.ms-word.document.macroenabled.12',
  dotm: 'application/vnd.ms-word.template.macroenabled.12',
  wri: 'application/x-mswrite',
  wps: 'application/vnd.ms-works',
  xbap: 'application/x-ms-xbap',
  xps: 'application/vnd.ms-xpsdocument',
  mid: 'audio/midi',
  mpy: 'application/vnd.ibm.minipay',
  afp: 'application/vnd.ibm.modcap',
  rms: 'application/vnd.jcp.javame.midlet-rms',
  tmo: 'application/vnd.tmobile-livetv',
  prc: 'application/x-mobipocket-ebook',
  mbk: 'application/vnd.mobius.mbk',
  dis: 'application/vnd.mobius.dis',
  plc: 'application/vnd.mobius.plc',
  mqy: 'application/vnd.mobius.mqy',
  msl: 'application/vnd.mobius.msl',
  txf: 'application/vnd.mobius.txf',
  daf: 'application/vnd.mobius.daf',
  fly: 'text/vnd.fly',
  mpc: 'application/vnd.mophun.certificate',
  mpn: 'application/vnd.mophun.application',
  mj2: 'video/mj2',
  mpga: 'audio/mpeg',
  mxu: 'video/vnd.mpegurl',
  mpeg: 'video/mpeg',
  m21: 'application/mp21',
  mp4a: 'audio/mp4',
  mp4: 'application/mp4',
  m3u8: 'application/vnd.apple.mpegurl',
  mus: 'application/vnd.musician',
  msty: 'application/vnd.muvee.style',
  mxml: 'application/xv+xml',
  ngdat: 'application/vnd.nokia.n-gage.data',
  'n-gage': 'application/vnd.nokia.n-gage.symbian.install',
  ncx: 'application/x-dtbncx+xml',
  nc: 'application/x-netcdf',
  nlu: 'application/vnd.neurolanguage.nlu',
  dna: 'application/vnd.dna',
  nnd: 'application/vnd.noblenet-directory',
  nns: 'application/vnd.noblenet-sealer',
  nnw: 'application/vnd.noblenet-web',
  rpst: 'application/vnd.nokia.radio-preset',
  rpss: 'application/vnd.nokia.radio-presets',
  n3: 'text/n3',
  edm: 'application/vnd.novadigm.edm',
  edx: 'application/vnd.novadigm.edx',
  ext: 'application/vnd.novadigm.ext',
  gph: 'application/vnd.flographit',
  ecelp4800: 'audio/vnd.nuera.ecelp4800',
  ecelp7470: 'audio/vnd.nuera.ecelp7470',
  ecelp9600: 'audio/vnd.nuera.ecelp9600',
  oda: 'application/oda',
  ogx: 'application/ogg',
  oga: 'audio/ogg',
  ogv: 'video/ogg',
  dd2: 'application/vnd.oma.dd2+xml',
  oth: 'application/vnd.oasis.opendocument.text-web',
  opf: 'application/oebps-package+xml',
  qbo: 'application/vnd.intu.qbo',
  oxt: 'application/vnd.openofficeorg.extension',
  osf: 'application/vnd.yamaha.openscoreformat',
  weba: 'audio/webm',
  webm: 'video/webm',
  odc: 'application/vnd.oasis.opendocument.chart',
  otc: 'application/vnd.oasis.opendocument.chart-template',
  odb: 'application/vnd.oasis.opendocument.database',
  odf: 'application/vnd.oasis.opendocument.formula',
  odft: 'application/vnd.oasis.opendocument.formula-template',
  odg: 'application/vnd.oasis.opendocument.graphics',
  otg: 'application/vnd.oasis.opendocument.graphics-template',
  odi: 'application/vnd.oasis.opendocument.image',
  oti: 'application/vnd.oasis.opendocument.image-template',
  odp: 'application/vnd.oasis.opendocument.presentation',
  otp: 'application/vnd.oasis.opendocument.presentation-template',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  ots: 'application/vnd.oasis.opendocument.spreadsheet-template',
  odt: 'application/vnd.oasis.opendocument.text',
  odm: 'application/vnd.oasis.opendocument.text-master',
  ott: 'application/vnd.oasis.opendocument.text-template',
  ktx: 'image/ktx',
  sxc: 'application/vnd.sun.xml.calc',
  stc: 'application/vnd.sun.xml.calc.template',
  sxd: 'application/vnd.sun.xml.draw',
  std: 'application/vnd.sun.xml.draw.template',
  sxi: 'application/vnd.sun.xml.impress',
  sti: 'application/vnd.sun.xml.impress.template',
  sxm: 'application/vnd.sun.xml.math',
  sxw: 'application/vnd.sun.xml.writer',
  sxg: 'application/vnd.sun.xml.writer.global',
  stw: 'application/vnd.sun.xml.writer.template',
  otf: 'application/x-font-otf',
  osfpvg: 'application/vnd.yamaha.openscoreformat.osfpvg+xml',
  dp: 'application/vnd.osgi.dp',
  pdb: 'application/vnd.palm',
  p: 'text/x-pascal',
  paw: 'application/vnd.pawaafile',
  pclxl: 'application/vnd.hp-pclxl',
  efif: 'application/vnd.picsel',
  pcx: 'image/x-pcx',
  psd: 'image/vnd.adobe.photoshop',
  prf: 'application/pics-rules',
  pic: 'image/x-pict',
  chat: 'application/x-chat',
  p10: 'application/pkcs10',
  p12: 'application/x-pkcs12',
  p7m: 'application/pkcs7-mime',
  p7s: 'application/pkcs7-signature',
  p7r: 'application/x-pkcs7-certreqresp',
  p7b: 'application/x-pkcs7-certificates',
  p8: 'application/pkcs8',
  plf: 'application/vnd.pocketlearn',
  pnm: 'image/x-portable-anymap',
  pbm: 'image/x-portable-bitmap',
  pcf: 'application/x-font-pcf',
  pfr: 'application/font-tdpfr',
  pgn: 'application/x-chess-pgn',
  pgm: 'image/x-portable-graymap',
  png: 'image/x-png',
  ppm: 'image/x-portable-pixmap',
  pskcxml: 'application/pskc+xml',
  pml: 'application/vnd.ctc-posml',
  ai: 'application/postscript',
  pfa: 'application/x-font-type1',
  pbd: 'application/vnd.powerbuilder6',
  pgp: 'application/pgp-signature',
  box: 'application/vnd.previewsystems.box',
  ptid: 'application/vnd.pvi.ptid1',
  pls: 'application/pls+xml',
  str: 'application/vnd.pg.format',
  ei6: 'application/vnd.pg.osasli',
  dsc: 'text/prs.lines.tag',
  psf: 'application/x-font-linux-psf',
  qps: 'application/vnd.publishare-delta-tree',
  wg: 'application/vnd.pmi.widget',
  qxd: 'application/vnd.quark.quarkxpress',
  esf: 'application/vnd.epson.esf',
  msf: 'application/vnd.epson.msf',
  ssf: 'application/vnd.epson.ssf',
  qam: 'application/vnd.epson.quickanime',
  qfx: 'application/vnd.intu.qfx',
  qt: 'video/quicktime',
  rar: 'application/x-rar-compressed',
  ram: 'audio/x-pn-realaudio',
  rmp: 'audio/x-pn-realaudio-plugin',
  rsd: 'application/rsd+xml',
  rm: 'application/vnd.rn-realmedia',
  bed: 'application/vnd.realvnc.bed',
  mxl: 'application/vnd.recordare.musicxml',
  musicxml: 'application/vnd.recordare.musicxml+xml',
  rnc: 'application/relax-ng-compact-syntax',
  rdz: 'application/vnd.data-vision.rdz',
  rdf: 'application/rdf+xml',
  rp9: 'application/vnd.cloanto.rp9',
  jisp: 'application/vnd.jisp',
  rtf: 'application/rtf',
  rtx: 'text/richtext',
  link66: 'application/vnd.route66.link66+xml',
  'rss, .xml': 'application/rss+xml',
  shf: 'application/shf+xml',
  st: 'application/vnd.sailingtracker.track',
  svg: 'image/svg+xml',
  sus: 'application/vnd.sus-calendar',
  sru: 'application/sru+xml',
  setpay: 'application/set-payment-initiation',
  setreg: 'application/set-registration-initiation',
  sema: 'application/vnd.sema',
  semd: 'application/vnd.semd',
  semf: 'application/vnd.semf',
  see: 'application/vnd.seemail',
  snf: 'application/x-font-snf',
  spq: 'application/scvp-vp-request',
  spp: 'application/scvp-vp-response',
  scq: 'application/scvp-cv-request',
  scs: 'application/scvp-cv-response',
  sdp: 'application/sdp',
  etx: 'text/x-setext',
  movie: 'video/x-sgi-movie',
  ifm: 'application/vnd.shana.informed.formdata',
  itp: 'application/vnd.shana.informed.formtemplate',
  iif: 'application/vnd.shana.informed.interchange',
  ipk: 'application/vnd.shana.informed.package',
  tfi: 'application/thraud+xml',
  shar: 'application/x-shar',
  rgb: 'image/x-rgb',
  slt: 'application/vnd.epson.salt',
  aso: 'application/vnd.accpac.simply.aso',
  imp: 'application/vnd.accpac.simply.imp',
  twd: 'application/vnd.simtech-mindmapper',
  csp: 'application/vnd.commonspace',
  saf: 'application/vnd.yamaha.smaf-audio',
  mmf: 'application/vnd.smaf',
  spf: 'application/vnd.yamaha.smaf-phrase',
  teacher: 'application/vnd.smart.teacher',
  svd: 'application/vnd.svd',
  rq: 'application/sparql-query',
  srx: 'application/sparql-results+xml',
  gram: 'application/srgs',
  grxml: 'application/srgs+xml',
  ssml: 'application/ssml+xml',
  skp: 'application/vnd.koan',
  sgml: 'text/sgml',
  sdc: 'application/vnd.stardivision.calc',
  sda: 'application/vnd.stardivision.draw',
  sdd: 'application/vnd.stardivision.impress',
  smf: 'application/vnd.stardivision.math',
  sdw: 'application/vnd.stardivision.writer',
  sgl: 'application/vnd.stardivision.writer-global',
  sm: 'application/vnd.stepmania.stepchart',
  sit: 'application/x-stuffit',
  sitx: 'application/x-stuffitx',
  sdkm: 'application/vnd.solent.sdkm+xml',
  xo: 'application/vnd.olpc-sugar',
  au: 'audio/basic',
  wqd: 'application/vnd.wqd',
  sis: 'application/vnd.symbian.install',
  smi: 'application/smil+xml',
  xsm: 'application/vnd.syncml+xml',
  bdm: 'application/vnd.syncml.dm+wbxml',
  xdm: 'application/vnd.syncml.dm+xml',
  sv4cpio: 'application/x-sv4cpio',
  sv4crc: 'application/x-sv4crc',
  sbml: 'application/sbml+xml',
  tsv: 'text/tab-separated-values',
  tiff: 'image/tiff',
  tao: 'application/vnd.tao.intent-module-archive',
  tar: 'application/x-tar',
  tcl: 'application/x-tcl',
  tex: 'application/x-tex',
  tfm: 'application/x-tex-tfm',
  tei: 'application/tei+xml',
  txt: 'text/plain',
  dxp: 'application/vnd.spotfire.dxp',
  sfs: 'application/vnd.spotfire.sfs',
  tsd: 'application/timestamped-data',
  tpt: 'application/vnd.trid.tpt',
  mxs: 'application/vnd.triscape.mxs',
  t: 'text/troff',
  tra: 'application/vnd.trueapp',
  ttf: 'application/x-font-ttf',
  ttl: 'text/turtle',
  umj: 'application/vnd.umajin',
  uoml: 'application/vnd.uoml+xml',
  unityweb: 'application/vnd.unity',
  ufd: 'application/vnd.ufdl',
  uri: 'text/uri-list',
  utz: 'application/vnd.uiq.theme',
  ustar: 'application/x-ustar',
  uu: 'text/x-uuencode',
  vcs: 'text/x-vcalendar',
  vcf: 'text/x-vcard',
  vcd: 'application/x-cdlink',
  vsf: 'application/vnd.vsf',
  wrl: 'model/vrml',
  vcx: 'application/vnd.vcx',
  mts: 'model/vnd.mts',
  vtu: 'model/vnd.vtu',
  vis: 'application/vnd.visionary',
  viv: 'video/vnd.vivo',
  ccxml: 'application/ccxml+xml,',
  vxml: 'application/voicexml+xml',
  src: 'application/x-wais-source',
  wbxml: 'application/vnd.wap.wbxml',
  wbmp: 'image/vnd.wap.wbmp',
  wav: 'audio/x-wav',
  davmount: 'application/davmount+xml',
  woff: 'application/x-font-woff',
  wspolicy: 'application/wspolicy+xml',
  webp: 'image/webp',
  wtb: 'application/vnd.webturbo',
  wgt: 'application/widget',
  hlp: 'application/winhlp',
  wml: 'text/vnd.wap.wml',
  wmls: 'text/vnd.wap.wmlscript',
  wmlsc: 'application/vnd.wap.wmlscriptc',
  wpd: 'application/vnd.wordperfect',
  stf: 'application/vnd.wt.stf',
  wsdl: 'application/wsdl+xml',
  xbm: 'image/x-xbitmap',
  xpm: 'image/x-xpixmap',
  xwd: 'image/x-xwindowdump',
  der: 'application/x-x509-ca-cert',
  fig: 'application/x-xfig',
  xhtml: 'application/xhtml+xml',
  xml: 'application/xml',
  xdf: 'application/xcap-diff+xml',
  xenc: 'application/xenc+xml',
  xer: 'application/patch-ops-error+xml',
  rl: 'application/resource-lists+xml',
  rs: 'application/rls-services+xml',
  rld: 'application/resource-lists-diff+xml',
  xslt: 'application/xslt+xml',
  xop: 'application/xop+xml',
  xpi: 'application/x-xpinstall',
  xspf: 'application/xspf+xml',
  xul: 'application/vnd.mozilla.xul+xml',
  xyz: 'chemical/x-xyz',
  yaml: 'text/yaml',
  yang: 'application/yang',
  yin: 'application/yin+xml',
  zir: 'application/vnd.zul',
  zip: 'application/zip',
  zmm: 'application/vnd.handheld-entertainment+xml',
  zaz: 'application/vnd.zzazz.deck+xml'
};
function downloadFile(data, name, fileType = 'csv') {
  const url = window.URL.createObjectURL(new Blob([data], {
    type: fileMimes[fileType]
  }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name ? `${name}.${fileType}` : `download.${fileType}`);
  document.body.appendChild(link);
  link.click();
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

const useRequestFile = ({
  getter,
  fileTitle,
  fileType,
  header
}) => {
  const {
    t,
    ready
  } = useTranslation(['translation']);
  const translation = ready ? {
    somethingWrong: t(`translation:somethingWrong`),
    errorButton: t(`translation:retry`)
  } : '';
  const {
    isOpen,
    isLoading,
    openDialog,
    closeDialog,
    startLoading,
    stopLoading,
    handleError,
    dialogErrorMessage
  } = useDialog();

  const requestFile = function () {
    try {
      startLoading();

      const _temp2 = _catch(function () {
        return Promise.resolve(getter()).then(function (response) {
          downloadFile(response.data, fileTitle, fileType);
          stopLoading();
        });
      }, function (error) {
        openDialog();

        const _temp = _catch(function () {
          var _error$response, _error$response$data;

          return Promise.resolve((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.text()).then(function (_error$response$data$) {
            var _JSON$parse, _JSON$parse$error;

            handleError((_JSON$parse = JSON.parse(_error$response$data$)) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$error = _JSON$parse.error) === null || _JSON$parse$error === void 0 ? void 0 : _JSON$parse$error.userMessage);
          });
        }, function () {
          handleError(translation === null || translation === void 0 ? void 0 : translation.somethingWrong);
        });

        return _temp && _temp.then ? _temp.then(function () {}) : void 0;
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const fileDialog = /*#__PURE__*/React.createElement(ResponseMessageDialog, {
    open: isOpen,
    dialogActions: /*#__PURE__*/React.createElement(PrimaryButtonLoader, {
      onClick: requestFile
    }, translation === null || translation === void 0 ? void 0 : translation.errorButton),
    closeDialog: closeDialog,
    dialogHeader: header,
    isLoading: isLoading,
    success: false
  }, dialogErrorMessage);
  return {
    requestFile,
    isLoading,
    fileDialog
  };
};

var styles = {"icon":"ExportButton-module_icon_2O-Fq"};

const ExportButton = ({
  title,
  fileTitle,
  getter,
  showTitle = true,
  fileType = 'csv'
}) => {
  const {
    fileDialog,
    isLoading,
    requestFile
  } = useRequestFile({
    getter,
    fileTitle,
    fileType,
    header: title
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrimaryButtonLoader, {
    "aria-label": title,
    title: title,
    onClick: requestFile,
    loading: isLoading
  }, /*#__PURE__*/React.createElement(DownloadIcon, {
    className: styles.icon
  }), showTitle ? title : null), fileDialog);
};

const getRandomInteger = () => {
  return Math.floor(Math.random() * 101);
};

const getRandomString = () => {
  return (Math.random() + 1).toString(36).substring(2);
};

export { ActionIconButton, AuthUserContext, AuthUserProvider, AuthorizedLayout, AuthorizedRoute, ConfirmationDialog, DetailsDialog, DialogErrorBox, ExportButton, FormDialog, FullWidthTableLayout, GeneralMessageDialog, IconLink, LimitedAccessContent, NavigationProfile, Profile, ResponseMessageDialog, Router, SWRconfig, SingleColumnLayout, SubRouteButton, TwoColumnsLayout, api, apiBlob, apiConfig, asyncInterval, authStorage, fetcher as blobFetcher, cancelCoupon, checkCouponCode, fetcher$1 as fetcher, formatDateToString, getFormDataFromJson, getRandomInteger, getRandomString, getTableColumns, getTableRows, getUser, login, logout, redeemCoupon, refreshToken, requestError, requestSuccess, sortStatus, useAuthUser, validateCouponPrefix, validateDateRangePicker };
